// i18n.js
import Module from '@/views/Module.vue';
import MyAccount from '@/views/MyAccount.vue';
import Rewards from '@/views/Rewards.vue';
import WhatsOn from '@/views/WhatsOn.vue';
import Video from '@/views/video.vue';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
// 第一个大写，后面小写，除了eXtra   Bosch，ID，
// 例外情况，最大的标题
Vue.use(VueI18n);

const messages = {
    vi: {
        //越南
        message: {
            PleaseCheckTheSignUpForEXtraProgram: "Please check the sign up for eXtra program!",
            monthlyOrderImport: "Monthly order import",
            SKUOrderImport: "SKU order import",
            FileCode: "File code",
            FileName: "File name",
            OrderMonth: "Order month",
            importTime: "Import time",
            Operate: "Operate",
            importNow: "Import now",
            DataFile: "Data file",
            ClickToUpload: "Click to upload",
            TemplateFile: "Template file",
            clickToDownloadTheMonthlyOrderTemplateFile: "click to download the monthly order template file",
            clickToDownloadTheSKUOrderTemplateFile: "Click to download the SKU order template file",
            importData: "Import data",
            manualUploading: "Manual uploading",
            Home: "Home",
            WhatSon: "What's on",
            Rewards: "Rewards",
            Module: "Module",
            TechWiki: "Auto tech",
            MyAccount: "My account",
            BOSCHAZPortal: "Bosch Business Portal",
            YourApplicationIsPendingReview: "Your application is pending review",
            CorporateInformation: "Corporate information",
            LegalNotice: "Legal notice",
            DataProtectionPolicy: "Data protection policy",
            PrivacySettings: "Privacy settings",
            RobertBoschGmbH: "© 2021 - 2025 Robert Bosch GmbH, all rights reserved",
            // 选择国家页:",",
            SelectCountry: "Select country",
            WarmingReminderYouCanOnlyAccessMalyssiaNow: "You can't access this country now. It will be coming soon! Please stay informed with us！",
            // 添加员工:",",
            AddEmployee: "Add Employee",
            FillInEmployeeInfo: "Fill in employee info",
            SheHeIs: "She/He is",
            YourApplicationIsAentToYourTheOwnerOfYourCompanyForApproval: "Your application is sent to the owner of your company for approval .",
            // 表单:",",
            Registration: "Registration",
            Step1: "Step 1",
            Step2: "Step 2",
            MobileNo: "Mobile NO.",
            FirstName: "First name",
            LastName: "Last name",
            CompanyName: "Company name",
            Email: "E-mail",
            EmailOptional: "Email",
            FullAddress: "Full address",
            Address: "Address",
            City: "City",
            PleaseEnter: "Please enter",
            ProvinceState: "Province / State",
            ZipCode: "Zip code",
            Continue: "Continue",
            Step3: "Step 3",
            IAmA: "I am a",
            IAm: "I am",
            RepairSegment: "Repair segment",
            VehicleSegment: "Vehicle segment",
            PreferredDistributor: "Preferred distributor",
            Workshop: "Workshop",
            Retailer: "Retailer",
            TradeLevel: "Trade level",
            PortalId: "Portal ID",
            Distributor: "Distributor",
            Diesel: "Diesel",
            Gasoline: "Gasoline",
            OthersEV: "Others (EV)",
            Motorcycle: "Motorcycle",
            PassengerCars: "Passenger cars",
            TrucksBus: "Trucks/Bus",
            NoOfWorkbay: "No. of workbay",
            FillIn: "Fill in",
            Namecard: "Namecard",
            TakeNamecard: "Take namecard",
            CompanyShopfront: "Company shopfront",
            PleaseUploadYourCompanyNamecard: "Please upload your company namecard",
            TakePhotoOfCompanyShopfront: "Take photo of company shopfront",
            PleaseUploadYourCompanyShopfront: "Please upload your company shopfront",
            SignUpForEXtraProgram: "Sign up for eXtra program",
            PleaseCheckAgain: "Please check again",
            IsTheGivenInformationCorrect: "Is the given information correct",
            DoYouAgreeOurPrivacyPolicy: "Do you agree our privacy policy",
            DoYouAgreeOurTermsConditions: "Do you agree our terms&Conditions",
            ConfirmToRegister: "Confirm to register",
            PleaseCheckIfTBD: "Please check if the given information is correct?（TBD)",
            Back: "Back",
            Confirm: "Confirm",
            PleaseCheckIfTheGivenInformationIsCorrect: "Please check if the given information is correct?",
            PleaseEnterTheRequiredInfo: "Please enter the required info",
            pleaseMakeSureIfYouWannaSignUpForEXtraProgram: "Please make sure if you wanna sign up for eXtra program",
            AlreadySubmittedPendingApproval: "Already submitted , pending approval",
            OwnerMobileNo: "Business/Office number.",
            Manager: "Manager",
            Employee: "Employee",
            Owner: "Responsible person",
            RequestANewOTP: "Request a new otp",
            YouHaveSelectdSMSAsNotificationChannel: "You have selectd SMS as notification channel, you will shortly receive an OTP to the mobile number you provided. please enter the OTP to complete your registration",
            DataProtectionGuidelines: "Data protection guidelines",
            GeneralTermsConditions: "General terms and conditions",
            PleaseEnterYourPhoneNumber: "Please enter your phone number",
            CellPhoneNumberIsRequired: "Cell phone number is required",
            pleaseAgreeOurTermsAndConditions: "Please agree our terms and conditions.",
            pleaseAgreeOurDataProtectionPolicy: "Please agree our Data protection policy.",
            pleaseAgreeOurLegalNotice: "Please agree our legal notice.",
            PleaseChooseYourRegion: "Please choose your region",
            PleaseEnterOTP: "Please enter otp",
            LoginToProceed: "Login to proceed",
            Login: "Login",
            RegisterNow: "Register now",
            DontHaveAnAccount: "Don’t have an account",
            OTP: "OTP",
            RequestANewOTP: "Request a new otp",
            YourApplicationIsPendingApproval: "Your application is pending approval, please wait a second!",
            success: "Success！",
            rule_list: "History version",
            AccountData: "Account Data",
            CountryRegion: "Country / Region",
            Role: "Role",
            ModifyBasicInformation: "Company photo",
            PleaseFillInYourEmail: "Your Email format is not correct, please enter again!",
            CompanyData: "Company data",
            eXtraID: "eXtra ID",
            ModifyInformation: "Modify information",
            ModifyKeyInformation: "Modify key information",
            ChangeCompanyPhoto: "Change company photo",
            LogOut: "Log out",
            NoDataAvailable: "No data available",
            Search: "Search",
            Modify: "Modify",
            PleaseCheckTheDataProtectionPolicyAndLegalNotice: "Please check data protection policy and legal notice!",
            // 人员管理:",",
            RoleManagement: "Role management",
            Time: "Time",
            Refuse: "Refuse",
            Accept: "Accept",
            DoYouConfirmToApproveIt: "Do you confirm to approve it?",
            DoYouConfirmToRejectIt: "Do you confirm to reject it?",
            PleaseConfirmAgain: "Notification",
            RoleInformation: "Role information",
            Name: "Name",
            Activate: "Activate",
            Disable: "Disable",
            IdentitySettings: "Identity settings",
            DoYouConfirmToChangeThisInformation: "Do you confirm to change this information?",
            DoYouConfirmToActivateThisAccount: "Do you confirm to activate this account？",
            DoYouConfirmToDisableThisAccount: "Do you confirm to disable this account?",
            // article:",",
            PurchaseRecord: "Purchase record",
            TotalPurchase: "Total purchase",
            valueSGD: "value (SGD)",
            TotalPurchaseValue: "Total purchase value",
            TotalPurchaseAmt: "Total purchase amt",
            ProcurementRecords: "Procurement records",
            View: "View",
            LatestArticles: "Latest articles",
            LearnMore: "Learn more >",
            // Autoparts:",",
            AutoParts: "Autoparts",
            ViewMore: "View more >",
            BoschGroup: "More About Bosch Group",
            BoschMobilityAftermarket: "Bosch Mobility Aftermarket Homepage",
            // BSSList:",",
            WelcomeBoschModulePartner: "Welcome Bosch Module partner!",
            MyBenefits: "My benefits >",
            MoreInfoAboutModule: "More info. about module >",
            AnnualPartsTarget: "Annual parts target",
            StillToGo: "Still-to-go",
            ContractTarget: "Contract target",
            TotalAchievement: "Total achievement",
            Year: "Year",
            ActualSales: "Actual sales",
            ContractPeriod: "Contract period",
            years: "Years",
            JoinDate: "Contract start date",
            KeepUpTheGreatProgress: "Keep up the great progress!",
            DealerWillGetInTouchWithYouSoon: "Dealer will get in touch with you soon.",
            ViewMyContract: "View my contract",
            Marketing: "Marketing",
            promotionZone: "Promotion zone",
            Attended: "In progress",
            Achieved: "Achieved",
            Received: "Received",
            Done: "Done",
            Abandoned: "Abandoned",
            to: "To",
            CurrentPurchase: "Current purchase",
            SGD: "SGD",
            MarketingPromotionZone: "Marketing promotion zone",
            NotAttended: "Not Available",
            // contact_us:",",
            Like: "Like",
            Comment: "Comment",
            SaySometihing: "Say sometihing",
            Sending: "Send",
            User: "User",
            PleaseTypeWords: "Please type words",
            AutomotiveTech: "Automotive Tech",
            views: "views",
            // Home:",",
            FunctionalityInDevelopment: "Functionality in development",
            // Module:",",
            Apply: "Apply",
            JoinUsLogIn: "Join us / Log in",
            JoinUs: "Join us",
            BoschModuleConcept: "Bosch module concept",
            IHaveReadAndAcceptedTheBoschModulePolicy: "I have read and accepted the Bosch module policy.",
            SignNow: "Sign Now",
            PleaseFillInTheBelowArea: "Please fill in the below area",
            PleaseFillInYourFirstNameUnrecognizedOrIncorrectSignatureWillLeadToRegistrationFailure: "Please fill in your First name. Unrecognized or incorrect signature will lead to registration failure",
            PlaeaseFillInYourFirstName: "Plaease fill in your first name",
            pleaseCheckTheBoschModulePolicy: "please check the Bosch module policy",
            KindlyProvideSignatureOrFullName: "Kindly provide full name",
            // MyAccount:",",
            loggedInSuccessfully: "Logged in successfully!",
            IAlreadyHaveAnOTP: "I already have an otp",
            Tel: "Tel",
            PendingIdentityForReview: "Pending identity for review",
            EnterBoschModuleTiering: "Enter Bosch Module tiering >",
            CurrentMember: "Current member",
            EarnPointsEveryDay: "Earn points every day",
            eXtraMall: "eXtra mall",
            eXtraPoints: "eXtra points",
            eXtraPoint: "eXtraPoint",
            Go: "Go",
            Redeem: "Redeem",
            MyServices: "My services",
            eXtra: "eXtra",
            Order: "Order",
            Points: "Points",
            Details: "Details",
            Personal: "Personal",
            Data: "Data",
            Privacy: "Privacy",
            Clause: "Clause",
            PersonalData: "Personal data",
            eXtraWokrshopCandidate: "Membership pending",
            KevinCarRepairServiceCenter: "Kevin car repair service center",
            MoreInfoAboutCompany: "More info about company",
            MoreInfoAboutYou: "More info about you",
            MyFirstName: "My first name",
            MyLastName: "My last name",
            BossMobileNumber: "Business/Office number",
            // Recordltem:",",
            time: "Time",
            item: "Item",
            Qty: "Qty",
            PN: "PN",
            dealer: "Dealer",
            Download: "Download",
            // Rewards:"0,",
            expiresOn: "Expires on",
            ActivityRules: "Activity rules",
            CheckInDone: "Check-in done",
            CheckInNOW: "Check-in now",
            ThePointsDataWillUpdateMonthlyPleaseStayInformedWithUs: "*The points data will update monthly.Please stay informed with us.",
            // Video:",",
            FoundTheQRCode: "Found the qr code",
            PleaseUseYourMobilePhoneToLog: "Please use your mobile phone to log on so as to scan product successfully!",
            PleaseAllowAuthorizedUseOfYourPhone: "Please allow authorized use of your phone camera and scan again!",
            // WhatsOn:",",
            ThoEvontTeasorGroupOllors: "Tho evont teasor group ollors tho possibility to prominently displny several evonts within one compent.",
            //刘新增 10/10:",",
            ModuleJoinData: "Module join date",
            ViewMyContract: "View my contract",
            NoContractHint: "We haven't found your contract, please contact your Bosch sales.",
            NoticeOfExpirationOfContract: "Your contract has expired! Please await Bosch arrangement for renewal.",
            ChannelPromotion: "Channel promotion",
            OK: "OK",
            Congratulations: "Congratulations!",
            YouHaveAchievedTheTarget: "You have achieved the target.,",
            PleaseAwaitBoschArrangementForYourEntitlement: "Please await Bosch arrangement for your entitlement!",
            ReceivedTheRewards: "Received the rewards",
            NotYetReceived: "Not yet received",
            // (10/12):",",
            WorkRole: "Work role",
            ICanNotFindMyDistributor: "Distributor name not found",
            AllAutoparts: "All autoparts",
            BatterySpecialist: "Battery specialist",
            Others: "Others",
            Cancel: "Cancel",
            PleaseEnterTheCorrectCompanyNameAndMobileNumber: "Please enter the correct company name and mobile number",
            ALL: "All",
            AccessOurFullRangeOfAvailableProductsOnTheGoSimplyClickOnYourProductGroupOfInterestToDiveIn: "Access our full range of available products on the go - simply click on your product group of interest to dive in!",
            searchPartnumberItem: "Search partnumber、item",
            searchPartnumberDealer: "Search partnumber、dealer",
            Send: "Send",
            Submit: "Submit",
            BoschAutopartsCustomerPortal: "Bosch Business Portal",
            //(10/14):",",
            Reset: "Reset",
            SelectAlanguage: "Select a language",
            NotFilled: "Not filled",
            Yes: "Yes",
            NO: "NO",
            StartTime: "Start time",
            EndTime: "End time",
            Product: "Product",
            PendingApproval: "Pending approval",
            AuditRejection: "Audit rejection",
            registered: "Registered",
            ResignedDisabled: " Resigned/Disabled",
            frozen: "frozen",
            PleaseRnterYourLoginAccount: "Please enter your loginAccount",
            AddEmployee: "Add Employee",
            ViewDetails: "View Details",
            YourRegistrationApplicationIsCurrentlyUnderReview: "Your registration application is currently under review.",
            IHaveTakenNoteOfThe: "I have taken note of the",
            DataProtectionNotice: "Data protection policy",
            ContactUs: "Contact us",
            YourDetails: "Your details",
            InquiryDetails: "Inquiry details",
            Description: "Description",
            Subject: "Subject",
            ModulesSignUp: "Modules sign up",
            PleaseFillInAllTheRequiredInformation: "Please fill in all the required information!",
            Expired: "Expired",
            PleaseAccessThroughMobileBrowser: "Please access through mobile browser",
            Enter: "Enter",
            Partnership: "Partnership",
            EGGMALL: "EGG MALL",
            CreateTheEGGMallAccount: "Create the EGG Mall account",
            Egg_hint: "You will authorize us to use your information to create the Egg Mall account, which will be bound to our account.",
            IAccept: "I accept",
            Egg_check_Policy: "《EGG Mall Privacy Policy》",
            ConfirmToCreate: "Confirm to create",
            PleaseCheckAndAcceptThePrivacyPolicy: "Please check and accept the privacy policy",
            CreationComplete: "Creation complete！",
            OverallAnnualBoshPurchase: "Overall annual Bosch purchase",
            // 勋章活动:",",
            WelcomeToTheBoschBusinessPortal: "Welcome to the Bosch Business Portal!",
            TBBPBAEFTOIOPJFYAABC: "The Bosch Business Portal brings all essential functions together in one place just for you as a Bosch customer.",
            TakeOurTourAndDiscoverWhatsInside: "Take our tour and discover what's inside!",
            StartTour: "Start tour",
            medalLayer1_head: "This tile will take you to our",
            medalLayer1: "e-catalogue,",
            medalLayer1_tail: ", where you can search and filter for all Bosch products available in your country.",
            medalLayer2_head: "Explore our,",
            medalLayer2: "news section",
            medalLayer2_tail: "to stay up to date with the latest articles and insights from the Bosch universe.",
            medalLayer3_head: "Our,",
            medalLayer3: "Smart Code",
            medalLayer3_tail: "helps you understand our Bosch Products better and can be found on our genuine Bosch products.Scan the QR code on your mobile device to find out more!",
            medalLayer3_btn: "mobile device.",
            medalLayer4_head: "This tile takes you to the,",
            medalLayer4: "eXtra rewards",
            medalLayer4_tail: " menu, where you can check your current points balance, scan products to earn more points, and much more!",
            medalLayer5_head: "Click the,",
            medalLayer5: "Automotive tech",
            medalLayer5_tail: " tile to go to our library of video tutorials and learn about our products.",
            medalLayer6_head: "Ever wondered about the,",
            medalLayer6: "Bosch Module program",
            medalLayer6_tail: "? Find out more by clicking on this tile!",
            FinishTour: "Finish tour",
            Step: "Step,",
            ofTo: " of,",
            HallOfFame: "Hall of Fame",
            BadgeEarned: "Badge earned",
            AvailableChallenges: "Available Challenges",
            StartChallenge: "Start challenge",
            ContinueChallenge: "Continue challenge",
            AvailableBadges: "Available Badges",
            FeedbackSurvey: "Feedback Survey",
            medal_form_1: "Now that you've seen a big part of the Bosch Business Portal already, we're interested in your opinion!",
            medal_form_2: "How do you rate the Bosch Business Portal",
            medal_form_3: "(1 - 5 stars)?",
            medal_form_4: "Which is your favorite feature of the portal?",
            medal_form_5: "E-catalogue",
            medal_form_6: "Modules Section",
            medal_form_7: "Auto-Tech",
            medal_form_8: "What’s On",
            medal_form_9: "Anti-fake",
            medal_form_10: "Any other comments?",
            medal_form_11: "We are lookforward to your comments, please enter any!",
            BadgeLeaderboard: "Badge Leaderboard",
            TheRankWillBeUpdatedByDay: "The rank will be updated by day.",
            AchievedTime: "Achieved Time",
            MyRank: "My Rank",
            ContinueToComplete: "Continue to complete",
            YouJustGotEXtraPointsRewardsRorCompleting: "You have just achieved",
            YouJustGotEXtraPointsRewardsRorCompleting2: "and received eXtra points!",
            YouJustEarnedBadge: "You just earned a badge",
            Collect: "Collect",
            FirstSteps: "First Steps",
            andPleaseKeepGoingOn: "and please keep going on!",
            Welcome: "Welcome",
            Welcome2: "Welcome to the Bosch Business Portal!,",
            layer2hint1: "Thank you for choosing Bosch.  Click on the button below to check out how you could complete exciting challenges, gain eXtra points and earn the Badges below!,",
            layer2hint2: "Hall of Fame",
            layer2hint3: "where you can earn badges and eXtrapoints along the way by completing challenges.",
            ContinueToExplore: "Continue to explore",
            TakeMeThere: "Take me there!  ",
            medal_form_list_1: "Achieved Time：You havent finished any challenge yet.",
            stepType5Hint: "Please achieve the previous steps first.",
            ContinueToAchieve: "Continue to achieve",
            // 25 6/11新增:"0,",
            ConnectYourEXtraAccount: "Connect your eXtra Account",
            ConnectYourEXtraAccount2: "Please enter your eXtra account and password, and we wilconnect your portal account with your eXtra account.",
            Account: "Account",
            EnterAccountNo: "Enter Account No.",
            Password: "Password",
            EnterPassword: "Enter Password",
            Submit: "Submit",
            // 25 5/9新增:"0,",
            SignUp: "Sign up",
            LogIn: "Login",
            LogIn_hint: "For existing users, please login. For new users, please sign up. Thank you!",
            LogIn_hint2: "For existing users, please login. For,",
            LogIn_hint2_1: "new users, please sign up. Thank you!",
            WelcomeToBoschBusinessPortal: "Welcome to Bosch Business Portal",
            WelcomeTo: "Welcome to",
            BoschBusinessPortal: "Bosch Business Portal",
            LogInSuccessfully: "Log in Successfully",
            GetYourRewards: "Get your rewards",
            WarmReminder: "You can use this function only after you pass the verification. Please hold on a second!",
            //2025 8/23新增:"0,",
            News_pdates: "News & updates",
            CustomerTrainingsEvents: "Customer trainings & events",
            News: "News",
            Promotion: "Promotion",
            E_Magizines: "E-Magazines",
            FileFormat: "File format",
            FindOutMoreHere: "Find out more here.",
            AccessPastTrainingsHere: "Access Past Trainings here!",
            AccessCurrentTrainingsHere: "Access Current Trainings here!",
            BDCHub: "BDC Area",
            BDCExcellenceHub: "BDC Area",
            BDCtitle: "News & Updates",
            BDCcenter: "Keep up to date with our current events and innovations from the Bosch world.",
            BDC_AutoPartsTitle: "Online Product Catalogue",
            BDC_AutoPartsCenter: "Explore Bosch product portfolio, including diesel and other product lines, with vehicle applications, OE cross-references, and detailed product information available on the go. Simply click the link below to explore.",
            bdcNAV1: "Parts Library",
            bdcNAV2: "Test equipment tools & Software",
            bdcNAV3: "BDC Excellence Hub",
            bdcNAV4: "DocuSearch**",
            CustomerTrainingstext1: "Welcome to Diesel & Beyond Training program!",
            CustomerTrainingstext1_center: "Diesel & Beyond is an empowering training program for the Bosch Diesel Network, designed to build competence and prepare the workshops for the future developments.With a comprehensive curriculum of both online and onsite, interactive learning formats, expert-led guidance, and certification opportunities, it equips workshops with the skills and knowledge to stay competitive and strengthen their position for future advancements.",
            CustomerTrainingstext1_hint: "",
            CustomerTrainingstext1_btnL: "Access Past Trainings here!",
            CustomerTrainingstext1_btnR: "Access Current Trainings here!",
            CustomerTrainingstext2: "Exciting Customer Events!",
            CustomerTrainingstext2_center: "We regularly organize interactive customer events, such as Diesel Night and conferences, to stay connected with our customers. Here in this session, you can conveniently review past events with presentations, photos, and materials, as well as discover upcoming events and networking opportunities - so you never miss important updates and insights.",
            CustomerTrainingstext2_btnL: "Access Past Events here!",
            CustomerTrainingstext2_btnR: "Access Current Events here!",
            CustomerTrainingsnav1_1: "Common Rail Diesel System",
            CustomerTrainingsnav1_2: "Conventional Diesel System",
            CustomerTrainingsnav1_3: "Exhaust Gas Treatment",
            CustomerTrainingsnav1_4: "Other Parts",
            NoDataAvailable2: "Currently, there are no active promotions.",
            // ModuleConcept:"",
            ModuleConcept_text1: "Số lượng gạt mưa cần thêm để nhận vé may mắn tiếp theo:",
            ModuleConcept_text2: "vé",
            ModuleConcept_text3: "Số vé may mắn bạn đang có",
            ModuleConcept_text4: "Tổng số gạt mưa đã mua",
            ModuleConcept_text5: "*Dữ liệu mua hàng sẽ được cập nhật ở tháng tiếp theo",
            ModuleConcept_text6: "Bảng xếp hạng tháng",
            ModuleConcept_text7: "月",
            ModuleConcept_text8: "Giới thiệu sự kiện kỷ niệm 100 năm Gạt mưa",

            //Wiper 100:"",
            Wiper_text1: "Wiper 100",
            Wiper_text2: "Kỷ niệm 100 năm Gạt mưa",
            Wiper_text3: "Vui lòng trả lời đúng câu hỏi sau để tham gia chương trình!",
            Wiper_text4: "Câu hỏi: Năm nay chúng ta kỷ niệm bao nhiêu năm Gạt mưa Bosch?",
            Wiper_text5: "A 60",
            Wiper_text6: "B 80",
            Wiper_text7: "C 100",
            Wiper_text8: "D 120",
            Wiper_text9: "Cơ hội trúng chuyến du lịch!",
            Wiper_text11: "Quay số và trúng thưởng",
            Wiper_text13: "Cùng Bosch kỷ niệm 100 năm Gạt mưa",
            Wiper_text14: "Quay số để nhận điểm thưởng!",
            Wiper_text15_1: "Bạn đã thu thập",
            Wiper_text15_2: " chữ cái!",
            Wiper_text15_3: " Đăng nhập lại để mở khóa cụm từ đầy đủ bên dưới và giải thưởng LỚN!",
            Wiper_text16: "Your Lucky Cards",
            Wiper_text17: "Chính xác! Hãy bắt đầu lễ kỷ niệm 100 năm Gạt mưa!",
            Wiper_text18: "Câu trả lời chưa đúng, vui lòng thử lại!",
            Wiper_text19: "Thẻ bạn đã thu thập",
            Wiper_text20: "Máy quay thưởng",
            Wiper_text21_1: "Chế độ Thường (Giải thưởng tối đa",
            Wiper_text21_2: " điểm)",
            Wiper_text22: "Lượt quay còn lại",
            Wiper_text23: "Quay",
            Wiper_text24: "Số chữ mới thu thập",
            Wiper_text25: "Chúc mừng đoạt giải",
            Wiper_text26: "Bạn đã nhận được",
            Wiper_text27: "Số lượt quay còn lại hôm nay",
            Wiper_text28: " điểm tích lũy",
            Wiper_text29: "Rất tiếc bạn chưa nhận được phần thưởng, hãy thử lại nhé!",
            Wiper_text30: "Dự kiến sẽ cập nhật vào tháng 4, mong các bạn kiên nhẫn chờ đợi!",
            Wiper_text31: "",


        }
    },
    en: {
        // 英语
        message: {
            PleaseCheckTheSignUpForEXtraProgram: "Please check the sign up for eXtra program!",
            monthlyOrderImport: "Monthly order import",
            SKUOrderImport: "SKU order import",
            FileCode: "File code",
            FileName: "File name",
            OrderMonth: "Order month",
            importTime: "Import time",
            Operate: "Operate",
            importNow: "Import now",
            DataFile: "Data file",
            ClickToUpload: "Click to upload",
            TemplateFile: "Template file",
            clickToDownloadTheMonthlyOrderTemplateFile: "click to download the monthly order template file",
            clickToDownloadTheSKUOrderTemplateFile: "Click to download the SKU order template file",
            importData: "Import data",
            manualUploading: "Manual uploading",
            Home: "Home",
            WhatSon: "What's on",
            Rewards: "Rewards",
            Module: "Module",
            TechWiki: "Auto tech",
            MyAccount: "My account",
            BOSCHAZPortal: "Bosch Business Portal",
            YourApplicationIsPendingReview: "Your application is pending review",
            CorporateInformation: "Corporate information",
            LegalNotice: "Legal notice",
            DataProtectionPolicy: "Data protection policy",
            PrivacySettings: "Privacy settings",
            RobertBoschGmbH: "© 2021 - 2025 Robert Bosch GmbH, all rights reserved",
            // 选择国家页:",",
            SelectCountry: "Select country",
            WarmingReminderYouCanOnlyAccessMalyssiaNow: "You can't access this country now. It will be coming soon! Please stay informed with us！",
            // 添加员工:",",
            AddEmployee: "Add Employee",
            FillInEmployeeInfo: "Fill in employee info",
            SheHeIs: "She/He is",
            YourApplicationIsAentToYourTheOwnerOfYourCompanyForApproval: "Your application is sent to the owner of your company for approval .",
            // 表单:",",
            Registration: "Registration",
            Step1: "Step 1",
            Step2: "Step 2",
            MobileNo: "Mobile NO.",
            FirstName: "First name",
            LastName: "Last name",
            CompanyName: "Company name",
            Email: "E-mail",
            EmailOptional: "Email",
            FullAddress: "Full address",
            Address: "Address",
            City: "City",
            PleaseEnter: "Please enter",
            ProvinceState: "Province / State",
            ZipCode: "Zip code",
            Continue: "Continue",
            Step3: "Step 3",
            IAmA: "I am a",
            IAm: "I am",
            RepairSegment: "Repair segment",
            VehicleSegment: "Vehicle segment",
            PreferredDistributor: "Preferred distributor",
            Workshop: "Workshop",
            Retailer: "Retailer",
            TradeLevel: "Trade level",
            PortalId: "Portal ID",
            Distributor: "Distributor",
            Diesel: "Diesel",
            Gasoline: "Gasoline",
            OthersEV: "Others (EV)",
            Motorcycle: "Motorcycle",
            PassengerCars: "Passenger cars",
            TrucksBus: "Trucks/Bus",
            NoOfWorkbay: "No. of workbay",
            FillIn: "Fill in",
            Namecard: "Namecard",
            TakeNamecard: "Take namecard",
            CompanyShopfront: "Company shopfront",
            PleaseUploadYourCompanyNamecard: "Please upload your company namecard",
            TakePhotoOfCompanyShopfront: "Take photo of company shopfront",
            PleaseUploadYourCompanyShopfront: "Please upload your company shopfront",
            SignUpForEXtraProgram: "Sign up for eXtra program",
            PleaseCheckAgain: "Please check again",
            IsTheGivenInformationCorrect: "Is the given information correct",
            DoYouAgreeOurPrivacyPolicy: "Do you agree our privacy policy",
            DoYouAgreeOurTermsConditions: "Do you agree our terms&Conditions",
            ConfirmToRegister: "Confirm to register",
            PleaseCheckIfTBD: "Please check if the given information is correct?（TBD)",
            Back: "Back",
            Confirm: "Confirm",
            PleaseCheckIfTheGivenInformationIsCorrect: "Please check if the given information is correct?",
            PleaseEnterTheRequiredInfo: "Please enter the required info",
            pleaseMakeSureIfYouWannaSignUpForEXtraProgram: "Please make sure if you wanna sign up for eXtra program",
            AlreadySubmittedPendingApproval: "Already submitted , pending approval",
            OwnerMobileNo: "Business/Office number.",
            Manager: "Manager",
            Employee: "Employee",
            Owner: "Responsible person",
            RequestANewOTP: "Request a new otp",
            YouHaveSelectdSMSAsNotificationChannel: "You have selectd SMS as notification channel, you will shortly receive an OTP to the mobile number you provided. please enter the OTP to complete your registration",
            DataProtectionGuidelines: "Data protection guidelines",
            GeneralTermsConditions: "General terms and conditions",
            PleaseEnterYourPhoneNumber: "Please enter your phone number",
            CellPhoneNumberIsRequired: "Cell phone number is required",
            pleaseAgreeOurTermsAndConditions: "Please agree our terms and conditions.",
            pleaseAgreeOurDataProtectionPolicy: "Please agree our Data protection policy.",
            pleaseAgreeOurLegalNotice: "Please agree our legal notice.",
            PleaseChooseYourRegion: "Please choose your region",
            PleaseEnterOTP: "Please enter otp",
            LoginToProceed: "Login to proceed",
            Login: "Login",
            RegisterNow: "Register now",
            DontHaveAnAccount: "Don’t have an account",
            OTP: "OTP",
            RequestANewOTP: "Request a new otp",
            YourApplicationIsPendingApproval: "Your application is pending approval, please wait a second!",
            success: "Success！",
            rule_list: "History version",
            AccountData: "Account Data",
            CountryRegion: "Country / Region",
            Role: "Role",
            ModifyBasicInformation: "Company photo",
            PleaseFillInYourEmail: "Your Email format is not correct, please enter again!",
            CompanyData: "Company data",
            eXtraID: "eXtra ID",
            ModifyInformation: "Modify information",
            ModifyKeyInformation: "Modify key information",
            ChangeCompanyPhoto: "Change company photo",
            LogOut: "Log out",
            NoDataAvailable: "No data available",
            Search: "Search",
            Modify: "Modify",
            PleaseCheckTheDataProtectionPolicyAndLegalNotice: "Please check data protection policy and legal notice!",
            // 人员管理:",",
            RoleManagement: "Role management",
            Time: "Time",
            Refuse: "Refuse",
            Accept: "Accept",
            DoYouConfirmToApproveIt: "Do you confirm to approve it?",
            DoYouConfirmToRejectIt: "Do you confirm to reject it?",
            PleaseConfirmAgain: "Notification",
            RoleInformation: "Role information",
            Name: "Name",
            Activate: "Activate",
            Disable: "Disable",
            IdentitySettings: "Identity settings",
            DoYouConfirmToChangeThisInformation: "Do you confirm to change this information?",
            DoYouConfirmToActivateThisAccount: "Do you confirm to activate this account？",
            DoYouConfirmToDisableThisAccount: "Do you confirm to disable this account?",
            // article:",",
            PurchaseRecord: "Purchase record",
            TotalPurchase: "Total purchase",
            valueSGD: "value (SGD)",
            TotalPurchaseValue: "Total purchase value",
            TotalPurchaseAmt: "Total purchase amt",
            ProcurementRecords: "Procurement records",
            View: "View",
            LatestArticles: "Latest articles",
            LearnMore: "Learn more >",
            // Autoparts:",",
            AutoParts: "Autoparts",
            ViewMore: "View more >",
            BoschGroup: "More About Bosch Group",
            BoschMobilityAftermarket: "Bosch Mobility Aftermarket Homepage",
            // BSSList:",",
            WelcomeBoschModulePartner: "Welcome Bosch Module partner!",
            MyBenefits: "My benefits >",
            MoreInfoAboutModule: "More info. about module >",
            AnnualPartsTarget: "Annual parts target",
            StillToGo: "Still-to-go",
            ContractTarget: "Contract target",
            TotalAchievement: "Total achievement",
            Year: "Year",
            ActualSales: "Actual sales",
            ContractPeriod: "Contract period",
            years: "Years",
            JoinDate: "Contract start date",
            KeepUpTheGreatProgress: "Keep up the great progress!",
            DealerWillGetInTouchWithYouSoon: "Dealer will get in touch with you soon.",
            ViewMyContract: "View my contract",
            Marketing: "Marketing",
            promotionZone: "Promotion zone",
            Attended: "In progress",
            Achieved: "Achieved",
            Received: "Received",
            Done: "Done",
            Abandoned: "Abandoned",
            to: "To",
            CurrentPurchase: "Current purchase",
            SGD: "SGD",
            MarketingPromotionZone: "Marketing promotion zone",
            NotAttended: "Not Available",
            // contact_us:",",
            Like: "Like",
            Comment: "Comment",
            SaySometihing: "Say sometihing",
            Sending: "Send",
            User: "User",
            PleaseTypeWords: "Please type words",
            AutomotiveTech: "Automotive Tech",
            views: "views",
            // Home:",",
            FunctionalityInDevelopment: "Functionality in development",
            // Module:",",
            Apply: "Apply",
            JoinUsLogIn: "Join us / Log in",
            JoinUs: "Join us",
            BoschModuleConcept: "Bosch module concept",
            IHaveReadAndAcceptedTheBoschModulePolicy: "I have read and accepted the Bosch module policy.",
            SignNow: "Sign Now",
            PleaseFillInTheBelowArea: "Please fill in the below area",
            PleaseFillInYourFirstNameUnrecognizedOrIncorrectSignatureWillLeadToRegistrationFailure: "Please fill in your First name. Unrecognized or incorrect signature will lead to registration failure",
            PlaeaseFillInYourFirstName: "Plaease fill in your first name",
            pleaseCheckTheBoschModulePolicy: "please check the Bosch module policy",
            KindlyProvideSignatureOrFullName: "Kindly provide full name",
            // MyAccount:",",
            loggedInSuccessfully: "Logged in successfully!",
            IAlreadyHaveAnOTP: "I already have an otp",
            Tel: "Tel",
            PendingIdentityForReview: "Pending identity for review",
            EnterBoschModuleTiering: "Enter Bosch Module tiering >",
            CurrentMember: "Current member",
            EarnPointsEveryDay: "Earn points every day",
            eXtraMall: "eXtra mall",
            eXtraPoints: "eXtra points",
            eXtraPoint: "eXtraPoint",
            Go: "Go",
            Redeem: "Redeem",
            MyServices: "My services",
            eXtra: "eXtra",
            Order: "Order",
            Points: "Points",
            Details: "Details",
            Personal: "Personal",
            Data: "Data",
            Privacy: "Privacy",
            Clause: "Clause",
            PersonalData: "Personal data",
            eXtraWokrshopCandidate: "Membership pending",
            KevinCarRepairServiceCenter: "Kevin car repair service center",
            MoreInfoAboutCompany: "More info about company",
            MoreInfoAboutYou: "More info about you",
            MyFirstName: "My first name",
            MyLastName: "My last name",
            BossMobileNumber: "Business/Office number",
            // Recordltem:",",
            time: "Time",
            item: "Item",
            Qty: "Qty",
            PN: "PN",
            dealer: "Dealer",
            Download: "Download",
            // Rewards:"0,",
            expiresOn: "Expires on",
            ActivityRules: "Activity rules",
            CheckInDone: "Check-in done",
            CheckInNOW: "Check-in now",
            ThePointsDataWillUpdateMonthlyPleaseStayInformedWithUs: "*The points data will update monthly.Please stay informed with us.",
            // Video:",",
            FoundTheQRCode: "Found the qr code",
            PleaseUseYourMobilePhoneToLog: "Please use your mobile phone to log on so as to scan product successfully!",
            PleaseAllowAuthorizedUseOfYourPhone: "Please allow authorized use of your phone camera and scan again!",
            // WhatsOn:",",
            ThoEvontTeasorGroupOllors: "Tho evont teasor group ollors tho possibility to prominently displny several evonts within one compent.",
            //刘新增 10/10:",",
            ModuleJoinData: "Module join date",
            ViewMyContract: "View my contract",
            NoContractHint: "We haven't found your contract, please contact your Bosch sales.",
            NoticeOfExpirationOfContract: "Your contract has expired! Please await Bosch arrangement for renewal.",
            ChannelPromotion: "Channel promotion",
            OK: "OK",
            Congratulations: "Congratulations!",
            YouHaveAchievedTheTarget: "You have achieved the target.,",
            PleaseAwaitBoschArrangementForYourEntitlement: "Please await Bosch arrangement for your entitlement!",
            ReceivedTheRewards: "Received the rewards",
            NotYetReceived: "Not yet received",
            // (10/12):",",
            WorkRole: "Work role",
            ICanNotFindMyDistributor: "Distributor name not found",
            AllAutoparts: "All autoparts",
            BatterySpecialist: "Battery specialist",
            Others: "Others",
            Cancel: "Cancel",
            PleaseEnterTheCorrectCompanyNameAndMobileNumber: "Please enter the correct company name and mobile number",
            ALL: "All",
            AccessOurFullRangeOfAvailableProductsOnTheGoSimplyClickOnYourProductGroupOfInterestToDiveIn: "Access our full range of available products on the go - simply click on your product group of interest to dive in!",
            searchPartnumberItem: "Search partnumber、item",
            searchPartnumberDealer: "Search partnumber、dealer",
            Send: "Send",
            Submit: "Submit",
            BoschAutopartsCustomerPortal: "Bosch Business Portal",
            //(10/14):",",
            Reset: "Reset",
            SelectAlanguage: "Select a language",
            NotFilled: "Not filled",
            Yes: "Yes",
            NO: "NO",
            StartTime: "Start time",
            EndTime: "End time",
            Product: "Product",
            PendingApproval: "Pending approval",
            AuditRejection: "Audit rejection",
            registered: "Registered",
            ResignedDisabled: " Resigned/Disabled",
            frozen: "frozen",
            PleaseRnterYourLoginAccount: "Please enter your loginAccount",
            AddEmployee: "Add Employee",
            ViewDetails: "View Details",
            YourRegistrationApplicationIsCurrentlyUnderReview: "Your registration application is currently under review.",
            IHaveTakenNoteOfThe: "I have taken note of the",
            DataProtectionNotice: "Data protection policy",
            ContactUs: "Contact us",
            YourDetails: "Your details",
            InquiryDetails: "Inquiry details",
            Description: "Description",
            Subject: "Subject",
            ModulesSignUp: "Modules sign up",
            PleaseFillInAllTheRequiredInformation: "Please fill in all the required information!",
            Expired: "Expired",
            PleaseAccessThroughMobileBrowser: "Please access through mobile browser",
            Enter: "Enter",
            Partnership: "Partnership",
            EGGMALL: "EGG MALL",
            CreateTheEGGMallAccount: "Create the EGG Mall account",
            Egg_hint: "You will authorize us to use your information to create the Egg Mall account, which will be bound to our account.",
            IAccept: "I accept",
            Egg_check_Policy: "《EGG Mall Privacy Policy》",
            ConfirmToCreate: "Confirm to create",
            PleaseCheckAndAcceptThePrivacyPolicy: "Please check and accept the privacy policy",
            CreationComplete: "Creation complete！",
            OverallAnnualBoshPurchase: "Overall annual Bosch purchase",
            // 勋章活动:",",
            WelcomeToTheBoschBusinessPortal: "Welcome to the Bosch Business Portal!",
            TBBPBAEFTOIOPJFYAABC: "The Bosch Business Portal brings all essential functions together in one place just for you as a Bosch customer.",
            TakeOurTourAndDiscoverWhatsInside: "Take our tour and discover what's inside!",
            StartTour: "Start tour",
            medalLayer1_head: "This tile will take you to our",
            medalLayer1: "e-catalogue,",
            medalLayer1_tail: ", where you can search and filter for all Bosch products available in your country.",
            medalLayer2_head: "Explore our,",
            medalLayer2: "news section",
            medalLayer2_tail: "to stay up to date with the latest articles and insights from the Bosch universe.",
            medalLayer3_head: "Our,",
            medalLayer3: "Smart Code",
            medalLayer3_tail: "helps you understand our Bosch Products better and can be found on our genuine Bosch products.Scan the QR code on your mobile device to find out more!",
            medalLayer3_btn: "mobile device.",
            medalLayer4_head: "This tile takes you to the,",
            medalLayer4: "eXtra rewards",
            medalLayer4_tail: " menu, where you can check your current points balance, scan products to earn more points, and much more!",
            medalLayer5_head: "Click the,",
            medalLayer5: "Automotive tech",
            medalLayer5_tail: " tile to go to our library of video tutorials and learn about our products.",
            medalLayer6_head: "Ever wondered about the,",
            medalLayer6: "Bosch Module program",
            medalLayer6_tail: "? Find out more by clicking on this tile!",
            FinishTour: "Finish tour",
            Step: "Step,",
            ofTo: " of,",
            HallOfFame: "Hall of Fame",
            BadgeEarned: "Badge earned",
            AvailableChallenges: "Available Challenges",
            StartChallenge: "Start challenge",
            ContinueChallenge: "Continue challenge",
            AvailableBadges: "Available Badges",
            FeedbackSurvey: "Feedback Survey",
            medal_form_1: "Now that you've seen a big part of the Bosch Business Portal already, we're interested in your opinion!",
            medal_form_2: "How do you rate the Bosch Business Portal",
            medal_form_3: "(1 - 5 stars)?",
            medal_form_4: "Which is your favorite feature of the portal?",
            medal_form_5: "E-catalogue",
            medal_form_6: "Modules Section",
            medal_form_7: "Auto-Tech",
            medal_form_8: "What’s On",
            medal_form_9: "Anti-fake",
            medal_form_10: "Any other comments?",
            medal_form_11: "We are lookforward to your comments, please enter any!",
            BadgeLeaderboard: "Badge Leaderboard",
            TheRankWillBeUpdatedByDay: "The rank will be updated by day.",
            AchievedTime: "Achieved Time",
            MyRank: "My Rank",
            ContinueToComplete: "Continue to complete",
            YouJustGotEXtraPointsRewardsRorCompleting: "You have just achieved",
            YouJustGotEXtraPointsRewardsRorCompleting2: "and received eXtra points!",
            YouJustEarnedBadge: "You just earned a badge",
            Collect: "Collect",
            FirstSteps: "First Steps",
            andPleaseKeepGoingOn: "and please keep going on!",
            Welcome: "Welcome",
            Welcome2: "Welcome to the Bosch Business Portal!,",
            layer2hint1: "Thank you for choosing Bosch.  Click on the button below to check out how you could complete exciting challenges, gain eXtra points and earn the Badges below!,",
            layer2hint2: "Hall of Fame",
            layer2hint3: "where you can earn badges and eXtrapoints along the way by completing challenges.",
            ContinueToExplore: "Continue to explore",
            TakeMeThere: "Take me there!  ",
            medal_form_list_1: "Achieved Time：You havent finished any challenge yet.",
            stepType5Hint: "Please achieve the previous steps first.",
            ContinueToAchieve: "Continue to achieve",
            // 25 6/11新增:"0,",
            ConnectYourEXtraAccount: "Connect your eXtra Account",
            ConnectYourEXtraAccount2: "Please enter your eXtra account and password, and we wilconnect your portal account with your eXtra account.",
            Account: "Account",
            EnterAccountNo: "Enter Account No.",
            Password: "Password",
            EnterPassword: "Enter Password",
            Submit: "Submit",
            // 25 5/9新增:"0,",
            SignUp: "Sign up",
            LogIn: "Login",
            LogIn_hint: "For existing users, please login. For new users, please sign up. Thank you!",
            LogIn_hint2: "For existing users, please login. For,",
            LogIn_hint2_1: "new users, please sign up. Thank you!",
            WelcomeToBoschBusinessPortal: "Welcome to Bosch Business Portal",
            WelcomeTo: "Welcome to",
            BoschBusinessPortal: "Bosch Business Portal",
            LogInSuccessfully: "Log in Successfully",
            GetYourRewards: "Get your rewards",
            WarmReminder: "You can use this function only after you pass the verification. Please hold on a second!",
            //2025 8/23新增:"0,",
            News_pdates: "News & updates",
            CustomerTrainingsEvents: "Customer trainings & events",
            News: "News",
            Promotion: "Promotion",
            E_Magizines: "E-Magazines",
            FileFormat: "File format",
            FindOutMoreHere: "Find out more here.",
            AccessPastTrainingsHere: "Access Past Trainings here!",
            AccessCurrentTrainingsHere: "Access Current Trainings here!",
            BDCHub: "BDC Area",
            BDCExcellenceHub: "BDC Area",
            BDCtitle: "News & Updates",
            BDCcenter: "Keep up to date with our current events and innovations from the Bosch world.",
            BDC_AutoPartsTitle: "Online Product Catalogue",
            BDC_AutoPartsCenter: "Explore Bosch product portfolio, including diesel and other product lines, with vehicle applications, OE cross-references, and detailed product information available on the go. Simply click the link below to explore.",
            bdcNAV1: "Parts Library",
            bdcNAV2: "Test equipment tools & Software",
            bdcNAV3: "BDC Excellence Hub",
            bdcNAV4: "DocuSearch**",
            CustomerTrainingstext1: "Welcome to Diesel & Beyond Training program!",
            CustomerTrainingstext1_center: "Diesel & Beyond is an empowering training program for the Bosch Diesel Network, designed to build competence and prepare the workshops for the future developments.With a comprehensive curriculum of both online and onsite, interactive learning formats, expert-led guidance, and certification opportunities, it equips workshops with the skills and knowledge to stay competitive and strengthen their position for future advancements.",
            CustomerTrainingstext1_hint: "",
            CustomerTrainingstext1_btnL: "Access Past Trainings here!",
            CustomerTrainingstext1_btnR: "Access Current Trainings here!",
            CustomerTrainingstext2: "Exciting Customer Events!",
            CustomerTrainingstext2_center: "We regularly organize interactive customer events, such as Diesel Night and conferences, to stay connected with our customers. Here in this session, you can conveniently review past events with presentations, photos, and materials, as well as discover upcoming events and networking opportunities - so you never miss important updates and insights.",
            CustomerTrainingstext2_btnL: "Access Past Events here!",
            CustomerTrainingstext2_btnR: "Access Current Events here!",
            CustomerTrainingsnav1_1: "Common Rail Diesel System",
            CustomerTrainingsnav1_2: "Conventional Diesel System",
            CustomerTrainingsnav1_3: "Exhaust Gas Treatment",
            CustomerTrainingsnav1_4: "Other Parts",
            NoDataAvailable2: "Currently, there are no active promotions.",
            // ModuleConcept:"",
            ModuleConcept_text1: "Number of wipers till to get your next lucky ticket: ",
            ModuleConcept_text2: "tickets",
            ModuleConcept_text3: "No. of lucky tickets you have",
            ModuleConcept_text4: "Total wipers purchased",
            ModuleConcept_text5: "Your purchase data will be updated next month.",
            ModuleConcept_text6: "Monthly Leaderboard",
            ModuleConcept_text7: "月",
            ModuleConcept_text8: "Wiper 100 Anniversary Introduction",

            //Wiper 100:"",
            Wiper_text1: "Wiper 100",
            Wiper_text2: "Wiper 100 Anniversary",
            Wiper_text3: "Please answer the following question correctly to participate our event!",
            Wiper_text4: "Q: How many years of Bosch wipers are we celebrating?",
            Wiper_text5: "A 60",
            Wiper_text6: "B 80",
            Wiper_text7: "C 100",
            Wiper_text8: "D 120",
            Wiper_text9: "Stand a chance to win a trip! ",
            Wiper_text11: "Spin and Win ",
            Wiper_text13: "Celebrating 100 years of Wipers with Bosch",
            Wiper_text14: "Spin to win points!",
            Wiper_text15_1: "You've collected",
            Wiper_text15_2: " letters!",
            Wiper_text15_3: " Log in again to unlock the full Phrase below, and the BIG jackpot!",
            Wiper_text16: "Your Lucky Cards",
            Wiper_text17: "That's right! Let the Wiper 100 celebrations begin!",
            Wiper_text18: "Wrong answer, please try again!",
            Wiper_text19: "Your Cards",
            Wiper_text20: "Slot Machine",
            Wiper_text21_1: "Normal Mode (Max Prize",
            Wiper_text21_2: " points)",
            Wiper_text22: "Spins Remaining",
            Wiper_text23: "Spin",
            Wiper_text24: "New Letter Collected",
            Wiper_text25: "You Win!",
            Wiper_text26: "You won",
            Wiper_text27: "Spins left today",
            Wiper_text28: " points",
            Wiper_text29: "Sorry! You have not received any rewards. Please try again.",
            Wiper_text30: "It is expected to be updated in April, please be patient!",
            Wiper_text31: "",


        }
    },
    id: {
        // 印尼
        message: {
            PleaseCheckTheSignUpForEXtraProgram: "Silakan periksa dan setuju untuk mendaftar di platform eXtra!",
            monthlyOrderImport: "Import perintah bulanan",
            SKUOrderImport: "Import perintah SKU",
            FileCode: "Kode berkas",
            FileName: "Nama berkas",
            OrderMonth: "Bulan perintah",
            importTime: "Waktu mengimport",
            Operate: "Operasi",
            importNow: "Import sekarang",
            DataFile: "Berkas data",
            ClickToUpload: "Klik untuk mengunggah",
            TemplateFile: "Berkas templat",
            clickToDownloadTheMonthlyOrderTemplateFile: "klik untuk mengunduh berkas templat perintah bulanan",
            clickToDownloadTheSKUOrderTemplateFile: "Klik untuk mengunduh berkas templat perintah SKU",
            importData: "Import data",
            manualUploading: "Mengupload secara manual",
            Home: "Laman Utama",
            WhatSon: "Yang tersedia",
            Rewards: "Hadiah",
            Module: "Modul",
            TechWiki: "Teknologi Otomotif",
            MyAccount: "Akun Saya",
            BOSCHAZPortal: "Portal Pelanggan Bosch Autoparts",
            YourApplicationIsPendingReview: "Aplikasi Anda sedang menunggu peninjauan",
            CorporateInformation: "Informasi perusahaan",
            LegalNotice: "Pemberitahuan hukum",
            DataProtectionPolicy: "Kebijakan perlindungan data",
            PrivacySettings: "Pengaturan privasi",
            RobertBoschGmbH: "© 2021 - 2025 Robert Bosch GmbH, semua hak dilindungi undang-undang",
            // 选择国家页:",",
            SelectCountry: "Pilih Negara",
            WarmingReminderYouCanOnlyAccessMalyssiaNow: "Saat ini, hanya platform Malaysia kami yang tersedia untuk diakses. Kami bekerja keras untuk segera menghadirkan negara lain secara online—nantikan pembaruan!",
            // 添加员工:",",
            AddEmployee: "Tambahkan karyawan",
            FillInEmployeeInfo: "Isi info karyawan",
            SheHeIs: "Dia adalah",
            YourApplicationIsAentToYourTheOwnerOfYourCompanyForApproval: "Aplikasi Anda dikirim ke pemilik perusahaan Anda untuk disetujui.",
            // 表单:",",
            Registration: "Pendaftaran",
            Step1: "Langkah 1",
            Step2: "Langkah 2",
            MobileNo: "Nomor ponsel.",
            FirstName: "Nama depan",
            LastName: "Nama belakang",
            CompanyName: "Nama Perusahaan",
            Email: "E-mail",
            EmailOptional: "E-mail",
            FullAddress: "Alamat lengkap",
            Address: "Alamat lengkap",
            City: "Kota",
            PleaseEnter: "Silahkan masukkan",
            ProvinceState: "Provinsi/negara bagian",
            ZipCode: "Kode pos",
            Continue: "terus",
            Step3: "Langkah 3",
            IAmA: "Saya adalah  ......",
            IAm: "Saya adalah  ......",
            RepairSegment: "Segmen Perbaikan",
            VehicleSegment: "Segmen Kendaraan",
            PreferredDistributor: "Distributor pilihan",
            Workshop: "Bengkel,",
            Retailer: "Pengecer",
            TradeLevel: "Pedagang",
            PortalId: "Id portal",
            Distributor: "Distributor",
            Diesel: "Diesel",
            Gasoline: "Bensin",
            OthersEV: "Lainnya (EV)",
            Motorcycle: "Sepeda motor",
            PassengerCars: "Mobil Penumpang",
            TrucksBus: "Truk/Bus",
            NoOfWorkbay: "Jumlah Tempat Kerja",
            FillIn: "Mengisi",
            Namecard: "Kartu nama",
            TakeNamecard: "Ambil Kartu Nama",
            CompanyShopfront: "Etalase Perusahaan",
            PleaseUploadYourCompanyNamecard: "Silakan unggah Kartu Nama Perusahaan Anda",
            TakePhotoOfCompanyShopfront: "Ambil foto Etalase Perusahaan",
            PleaseUploadYourCompanyShopfront: "Silakan unggah etalase Perusahaan Anda",
            SignUpForEXtraProgram: "Daftar untuk program eXtra",
            PleaseCheckAgain: "Silakan periksa lagi!,",
            IsTheGivenInformationCorrect: "Apakah informasi yang diberikan benar?",
            DoYouAgreeOurPrivacyPolicy: "Apakah Anda setuju dengan kebijakan privasi kami?",
            DoYouAgreeOurTermsConditions: "Apakah Anda setuju dengan syarat & ketentuan kami?",
            ConfirmToRegister: "Konfirmasi untuk Mendaftar",
            PleaseCheckIfTBD: "Silakan periksa apakah informasi yang diberikan sudah benar?",
            Back: "belakang",
            Confirm: "Mengkonfirmasi",
            PleaseCheckIfTheGivenInformationIsCorrect: "Silakan periksa apakah informasi yang diberikan sudah benar?",
            PleaseEnterTheRequiredInfo: "Silakan masukkan info yang diperlukan",
            pleaseMakeSureIfYouWannaSignUpForEXtraProgram: "pastikan jika Anda ingin mendaftar untuk program eXtra",
            AlreadySubmittedPendingApproval: "Sudah dikirimkan, menunggu persetujuan!",
            OwnerMobileNo: "Boss Mobile No.,",
            Manager: "manajer",
            Employee: "Karyawan",
            Owner: "Bos",
            RequestANewOTP: "Minta OTP baru",
            YouHaveSelectdSMSAsNotificationChannel: "Anda telah memilih SMS sebagai saluran notifikasi, Anda akan segera menerima OTP ke nomor ponsel yang Anda berikan. silakan masukkan OTP untuk menyelesaikan pendaftaran Anda",
            DataProtectionGuidelines: "Pedoman Perlindungan Data",
            GeneralTermsConditions: "Syarat dan Ketentuan Umum",
            PleaseEnterYourPhoneNumber: "Masukkan nomor telepon Anda",
            CellPhoneNumberIsRequired: "Nomor ponsel diperlukan!",
            pleaseAgreeOurTermsAndConditions: "Mohon setujui syarat dan ketentuan kami.",
            pleaseAgreeOurDataProtectionPolicy: "mohon setujui kebijakan perlindungan data kami.",
            pleaseAgreeOurLegalNotice: "mohon setujui Pemberitahuan Hukum kami.",
            PleaseChooseYourRegion: "Silakan pilih wilayah Anda",
            PleaseEnterOTP: "Silahkan masukkan OTP",
            LoginToProceed: "Login untuk Melanjutkan",
            Login: "Login",
            RegisterNow: "Daftar Sekarang",
            DontHaveAnAccount: "Tidak memiliki akun",
            OTP: "OTP",
            RequestANewOTP: "Minta OTP baru",
            YourApplicationIsPendingApproval: "Aplikasi Anda sedang menunggu persetujuan, harap tunggu sebentar!",
            success: "keberhasilan!",
            rule_list: "Versi Sejarah",
            AccountData: "Data Akun",
            CountryRegion: "Negara / Wilayah",
            Role: "Peran",
            ModifyBasicInformation: "Foto perusahaan",
            PleaseFillInYourEmail: "Format email Anda salah, silakan masukkan kembali!",
            CompanyData: "Data perusahaan",
            eXtraID: "ID eXtra",
            ModifyInformation: "Ubah informasi",
            ModifyKeyInformation: "Mengubah informasi kunci",
            ChangeCompanyPhoto: "Ganti foto perusahaan",
            LogOut: "Keluar",
            NoDataAvailable: "Tidak ada data yang tersedia",
            Search: "Mencari",
            Modify: "Memodifikasi",
            PleaseCheckTheDataProtectionPolicyAndLegalNotice: "Silakan periksa kebijakan perlindungan data dan pemberitahuan hukum!",
            // 人员管理:",",
            RoleManagement: "Posisi Manajemen",
            Time: "Waktu",
            Refuse: "Menolak",
            Accept: "Terima",
            DoYouConfirmToApproveIt: "Apakah Anda mengonfirmasi untuk menyetujuinya?",
            DoYouConfirmToRejectIt: "Apakah Anda mengonfirmasi untuk menolaknya?",
            PleaseConfirmAgain: "Pemberitahuan",
            RoleInformation: "Informasi peran",
            Name: "Name",
            Activate: "Mengaktifkan",
            Disable: "Dinonaktifkan",
            IdentitySettings: "Pengaturan identitas",
            DoYouConfirmToChangeThisInformation: "Apakah Anda mengonfirmasi untuk mengubah informasi ini?",
            DoYouConfirmToActivateThisAccount: "Apakah Anda mengonfirmasi untuk mengaktifkan akun ini?",
            DoYouConfirmToDisableThisAccount: "Apakah Anda mengonfirmasi untuk menonaktifkan akun ini?",
            // article:",",
            PurchaseRecord: "Catatan pembelian",
            TotalPurchase: "Total pembelian",
            valueSGD: "Nilai Jumlah Pembelian (IDR)",
            TotalPurchaseValue: "Total nilai pembelian",
            TotalPurchaseAmt: "Jumlah pembelian total",
            ProcurementRecords: "Catatan pengadaan",
            View: "Melihat",
            LatestArticles: "Artikel Terbaru",
            LearnMore: "Pelajari lebih lanjut >",
            // Autoparts:",",
            AutoParts: "Suku Cadang Mobil",
            ViewMore: "Lihat lebih banyak >",
            BoschGroup: "Grup Bosch",
            BoschMobilityAftermarket: "Bursa Mobilitas Bosch",
            // BSSList:",",
            WelcomeBoschModulePartner: "Selamat Datang Mitra Modul Bosch",
            MyBenefits: "Manfaat saya >",
            MoreInfoAboutModule: "Info lebih lanjut. tentang Modul >",
            AnnualPartsTarget: "Target suku cadang tahunan",
            StillToGo: "Masih harus pergi",
            ContractTarget: "Target kontrak",
            TotalAchievement: "Total pencapaian",
            Year: "tahun",
            ActualSales: "Penjualan aktual",
            ContractPeriod: "Masa Kontrak",
            years: "tahun",
            JoinDate: "Tanggal Mulai Kontrak",
            KeepUpTheGreatProgress: "Pertahankan kemajuan besar!",
            DealerWillGetInTouchWithYouSoon: "Dealer akan segera menghubungi Anda.",
            ViewMyContract: "Lihat Kontrak Saya",
            Marketing: "Pemasaran",
            promotionZone: "Zona promosi",
            Attended: "Dalam Proses",
            Achieved: "Bisa dikatakan",
            Received: "Menerima",
            Done: "Selesai",
            Abandoned: "Ditinggalkan",
            to: "ke",
            CurrentPurchase: "Pembelian saat ini",
            SGD: "IDR",
            MarketingPromotionZone: "Zona promosi pemasaran",
            NotAttended: "Tidak tersedia",
            // contact_us:",",
            Like: "Suka",
            Comment: "Komentar",
            SaySometihing: "Katakan sesuatu",
            Sending: "Kirim",
            User: "Pengguna",
            PleaseTypeWords: "Silakan ketik kata-kata",
            AutomotiveTech: "Teknologi Otomotif",
            views: "Dilihat",
            // Home:",",
            FunctionalityInDevelopment: "Fungsionalitas dalam pengembangan",
            // Module:",",
            Apply: "aplikasi",
            JoinUsLogIn: "Bergabung dengan kami / Daftar masuk",
            JoinUs: "Bergabunglah dengan kami",
            BoschModuleConcept: "Konsep Bosch Module,",
            IHaveReadAndAcceptedTheBoschModulePolicy: "Saya telah membaca dan menerima kebijakan Bosch module",
            SignNow: "Daftar Sekarang",
            PleaseFillInTheBelowArea: "Silahkan isi area di bawah ini",
            PleaseFillInYourFirstNameUnrecognizedOrIncorrectSignatureWillLeadToRegistrationFailure: "Silakan isi nama depan Anda. Tanda tangan yang tidak dikenali atau salah akan menyebabkan kegagalan pendaftaran",
            PlaeaseFillInYourFirstName: "Plaease isi nama depan Anda",
            pleaseCheckTheBoschModulePolicy: "silakan periksa kebijakan Bosch Module,",
            KindlyProvideSignatureOrFullName: "Mohon berikan tanda tangan atau nama lengkap",
            // MyAccount:",",
            loggedInSuccessfully: "berhasil masuk!",
            IAlreadyHaveAnOTP: "Saya sudah memiliki OTP",
            Tel: "Telepon",
            PendingIdentityForReview: "Identitas yang menunggu untuk ditinjau",
            EnterBoschModuleTiering: "Masuk ke Tiering Bosch Module,",
            CurrentMember: "Anggota saat ini",
            EarnPointsEveryDay: "Dapatkan poin setiap hari",
            eXtraMall: "Mal eXtra",
            eXtraPoints: "Poin eXtra",
            eXtraPoint: "Poin eXtra",
            Go: "Pergi,",
            Redeem: "Tebus",
            MyServices: "Layanan Saya,",
            eXtra: "eXtra",
            Order: "Pesanan",
            Points: "poin",
            Details: "Rincian",
            Personal: "Pribadi",
            Data: "Data",
            Privacy: "Privasi",
            Clause: "Klausul",
            PersonalData: "Data pribadi",
            eXtraWokrshopCandidate: "Keanggotaan tertunda",
            KevinCarRepairServiceCenter: "Kevin Car repair service center",
            MoreInfoAboutCompany: "Info lebih lanjut tentang Perusahaan",
            MoreInfoAboutYou: "Info selengkapnya tentang Anda",
            MyFirstName: "Nama depan saya",
            MyLastName: "Nama belakang saya",
            BossMobileNumber: "Nomor ponsel bos",
            // Recordltem:",",
            time: "Waktu",
            item: "Produk",
            Qty: "Jumlah",
            PN: "PN",
            dealer: "dealer",
            Download: "mengunduh",
            // Rewards:"balan ,",
            expiresOn: "kedaluwarsa pada",
            ActivityRules: "Aturan aktivitas",
            CheckInDone: "Check-in selesai",
            CheckInNOW: "Check-in SEKARANG",
            ThePointsDataWillUpdateMonthlyPleaseStayInformedWithUs: "Data poin akan diperbarui setiap bulan. Harap tetap terinformasi bersama kami.",
            // Video:",",
            FoundTheQRCode: "Menemukan Kode QR",
            PleaseUseYourMobilePhoneToLog: "Silakan gunakan ponsel Anda untuk masuk agar berhasil memindai produk!",
            PleaseAllowAuthorizedUseOfYourPhone: "Harap izinkan penggunaan kamera ponsel Anda secara resmi dan pindai lagi!",
            // WhatsOn:",",
            ThoEvontTeasorGroupOllors: "Berita apa yang ada",
            //刘新增 10/10:",",
            ModuleJoinData: "Data modul",
            ViewMyContract: "Lihat Kontrak Saya",
            NoContractHint: "Kami belum menemukan kontrakmu.",
            NoticeOfExpirationOfContract: "Kontrakmu sudah habis! Tolong tunggu Bosch untuk mengatur pembaruan.",
            ChannelPromotion: "Promosi saluran",
            OK: "bagus",
            Congratulations: "Selamat",
            YouHaveAchievedTheTarget: "Anda telah mencapai tujuan Anda.",
            PleaseAwaitBoschArrangementForYourEntitlement: "Tolong tunggu Bosch untuk mengatur hakmu!",
            ReceivedTheRewards: "Hadiah yang diterima",
            NotYetReceived: "Belum diterima",
            // (10/12):",",
            WorkRole: "Rol Tugas",
            ICanNotFindMyDistributor: "Tidak bisa menemukan dealer saya",
            AllAutoparts: "Semua bagian Auto",
            BatterySpecialist: "Baterai terkait",
            Others: "其他",
            Cancel: "batalkan",
            PleaseEnterTheCorrectCompanyNameAndMobileNumber: "Silakan masukkan nama perusahaan yang benar dan nomor telepon",
            ALL: "seluruh",
            AccessOurFullRangeOfAvailableProductsOnTheGoSimplyClickOnYourProductGroupOfInterestToDiveIn: "Akses seluruh gam produk yang tersedia kapanpun, dimanapun - hanya klik pada grup produk yang menarik Anda untuk belajar lebih!",
            searchPartnumberItem: "Cari nomor bagian, item",
            searchPartnumberDealer: "Cari nomor bagian, dealer",
            Send: "Dapatkan kode verifikasi",
            Submit: "Kirim",
            BoschAutopartsCustomerPortal: "",
            //(10/14):",",
            Reset: "Reset",
            SelectAlanguage: "tukar bahasa",
            NotFilled: "Tidak ada data tersedia",
            Yes: "ya",
            NO: "Tidak",
            StartTime: "waktu awal",
            EndTime: "Waktu akhir",
            Product: "produk",
            PendingApproval: "Revisi tunggu",
            AuditRejection: "Review gagal",
            registered: "aktif",
            ResignedDisabled: "Lumpuhkan/Batalkan",
            frozen: "beku",
            PleaseRnterYourLoginAccount: "Aplikasi telah dikirim di toko perbaikan. Silakan beritahu bos untuk pemeriksaan",
            AddEmployee: "Tambahkan karyawan",
            ViewDetails: "Tampilkan informasi rincian",
            YourRegistrationApplicationIsCurrentlyUnderReview: "Aplikasi pendaftaran Anda saat ini sedang diuji.",
            IHaveTakenNoteOfThe: "Aku menyadari",
            DataProtectionNotice: "Kebijakan perlindungan data",
            ContactUs: "hubungi kami",
            YourDetails: "Informasi rincianmu",
            InquiryDetails: "Cari rincian",
            Description: "deskripsikan",
            Subject: "tema",
            ModulesSignUp: "Registrasi modul",
            PleaseFillInAllTheRequiredInformation: "Silakan isi semua informasi yang diperlukan!",
            Expired: "habis",
            PleaseAccessThroughMobileBrowser: "Silakan akses melalui browser ponsel",
            Enter: "Enter",
            Partnership: "",
            EGGMALL: "",
            CreateTheEGGMallAccount: "",
            Egg_hint: "",
            IAccept: "",
            Egg_check_Policy: "",
            ConfirmToCreate: "",
            PleaseCheckAndAcceptThePrivacyPolicy: "",
            CreationComplete: "",
            OverallAnnualBoshPurchase: "Total pembelian tahunan Bosch",
            // 勋章活动:",",
            WelcomeToTheBoschBusinessPortal: "",
            TBBPBAEFTOIOPJFYAABC: "",
            TakeOurTourAndDiscoverWhatsInside: "",
            StartTour: "",
            medalLayer1_head: "",
            medalLayer1: "",
            medalLayer1_tail: "",
            medalLayer2_head: "",
            medalLayer2: "",
            medalLayer2_tail: "",
            medalLayer3_head: "",
            medalLayer3: "",
            medalLayer3_tail: "",
            medalLayer3_btn: "",
            medalLayer4_head: "",
            medalLayer4: "",
            medalLayer4_tail: "",
            medalLayer5_head: "",
            medalLayer5: "",
            medalLayer5_tail: "",
            medalLayer6_head: "",
            medalLayer6: "",
            medalLayer6_tail: "",
            FinishTour: "",
            Step: "",
            ofTo: "",
            HallOfFame: "",
            BadgeEarned: "",
            AvailableChallenges: "",
            StartChallenge: "",
            ContinueChallenge: "",
            AvailableBadges: "",
            FeedbackSurvey: "",
            medal_form_1: "",
            medal_form_2: "",
            medal_form_3: "",
            medal_form_4: "",
            medal_form_5: "",
            medal_form_6: "",
            medal_form_7: "",
            medal_form_8: "",
            medal_form_9: "",
            medal_form_10: "",
            medal_form_11: "",
            BadgeLeaderboard: "",
            TheRankWillBeUpdatedByDay: "",
            AchievedTime: "",
            MyRank: "",
            ContinueToComplete: "",
            YouJustGotEXtraPointsRewardsRorCompleting: "",
            YouJustGotEXtraPointsRewardsRorCompleting2: "",
            YouJustEarnedBadge: "",
            Collect: "",
            FirstSteps: "",
            andPleaseKeepGoingOn: "",
            Welcome: "",
            Welcome2: "",
            layer2hint1: "",
            layer2hint2: "",
            layer2hint3: "",
            ContinueToExplore: "",
            TakeMeThere: "",
            medal_form_list_1: "",
            stepType5Hint: "",
            ContinueToAchieve: "",
            // 25 6/11新增:",",
            ConnectYourEXtraAccount: "",
            ConnectYourEXtraAccount2: "",
            Account: "",
            EnterAccountNo: "",
            Password: "",
            EnterPassword: "",
            Submit: "",
            // 25 5/9新增:",",
            SignUp: "",
            LogIn: "Login",
            LogIn_hint: "",
            LogIn_hint2: "",
            LogIn_hint2_1: "",
            WelcomeToBoschBusinessPortal: "",
            WelcomeTo: "",
            BoschBusinessPortal: "",
            LogInSuccessfully: "",
            GetYourRewards: "Get your rewards",
            WarmReminder: "",
            //2025 8/23新增:",",
            News_pdates: "",
            CustomerTrainingsEvents: "",
            News: "",
            Promotion: "",
            E_Magizines: "",
            FileFormat: "",
            FindOutMoreHere: "",
            AccessPastTrainingsHere: "",
            AccessCurrentTrainingsHere: "",
            BDCHub: "",
            BDCExcellenceHub: "",
            BDCtitle: "",
            BDCcenter: "",
            BDC_AutoPartsTitle: "",
            BDC_AutoPartsCenter: "",
            bdcNAV1: "",
            bdcNAV2: "",
            bdcNAV3: "",
            bdcNAV4: "",
            CustomerTrainingstext1: "",
            CustomerTrainingstext1_center: "",
            CustomerTrainingstext1_hint: "",
            CustomerTrainingstext1_btnL: "",
            CustomerTrainingstext1_btnR: "",
            CustomerTrainingstext2: "",
            CustomerTrainingstext2_center: "",
            CustomerTrainingstext2_btnL: "",
            CustomerTrainingstext2_btnR: "",
            CustomerTrainingsnav1_1: "",
            CustomerTrainingsnav1_2: "",
            CustomerTrainingsnav1_3: "",
            CustomerTrainingsnav1_4: "",
            NoDataAvailable2: "",
            // ModuleConcept:"",
            ModuleConcept_text1: "Jumlah wiper yang dibutuhkan untuk mendapatkan kupon undian berikutnya:",
            ModuleConcept_text2: "kupon",
            ModuleConcept_text3: "Jumlah kupon undian yang Anda miliki",
            ModuleConcept_text4: "Total wiper yang telah dibeli",
            ModuleConcept_text5: "*Data pembelian akan diperbarui setiap bulan",
            ModuleConcept_text6: "Papan Peringkat Bulanan",
            ModuleConcept_text7: "月",
            ModuleConcept_text8: "Pengenalan Perayaan 100 Tahun Wiper",

            //Wiper 100:"",
            Wiper_text1: "Wiper 100",
            Wiper_text2: "Perayaan 100 Tahun Wiper",
            Wiper_text3: "Jawab pertanyaan berikut dengan benar untuk mengikuti acara kami!",
            Wiper_text4: "Pertanyaan: Tahun ini kita merayakan berapa tahun Wiper Bosch?",
            Wiper_text5: "A 60",
            Wiper_text6: "B 80",
            Wiper_text7: "C 100",
            Wiper_text8: "D 120",
            Wiper_text9: "Berkesempatan memenangkan perjalanan wisata!",
            Wiper_text11: "Ikuti dan menang",
            Wiper_text13: "Merayakan 100 Tahun Wiper bersama Bosch",
            Wiper_text14: "Putar untuk memenangkan poin!",
            Wiper_text15_1: "Anda telah mengumpulkan",
            Wiper_text15_2: " huruf! ",
            Wiper_text15_3: " Login kembali untuk membuka frasa lengkap di bawah dan jackpot BESAR!",
            Wiper_text16: "Your Lucky Cards",
            Wiper_text17: "Benar! Mari mulai perayaan 100 Tahun Wiper!",
            Wiper_text18: "Jawaban salah, silakan coba lagi!",
            Wiper_text19: "Kartu yang Anda kumpulkan",
            Wiper_text20: "Mesin permainan",
            Wiper_text21_1: "Mode Normal (Hadiah maks",
            Wiper_text21_2: " poin)",
            Wiper_text22: "Sisa Putaran",
            Wiper_text23: "Putar",
            Wiper_text24: "Huruf baru terkumpul",
            Wiper_text25: "Selamat atas kemenangan Anda",
            Wiper_text26: "Anda telah mendapatkan",
            Wiper_text27: "Sisa kesempatan undian hari ini",
            Wiper_text28: " poin",
            Wiper_text29: "Maaf, Anda tidak mendapatkan hadiah, silakan coba lagi!",
            Wiper_text30: "Diperkirakan akan diperbarui pada bulan April, harap bersabar!",
            Wiper_text31: "",


        }
    },
    th: {
        // 泰国
        message: {
            PleaseCheckTheSignUpForEXtraProgram: "โปรดติ๊กและตกลงที่จะลงทะเบียนแพลตฟอร์ม eXtra!",
            monthlyOrderImport: "นำเข้าคำสั่งรายเดือน",
            SKUOrderImport: "นำเข้าคำสั่ง SKU",
            FileCode: "การเข้ารหัสไฟล์",
            FileName: "ชื่อแฟ้ม",
            OrderMonth: "สั่งดวงจันทร์",
            importTime: "เวลานำเข้า",
            Operate: "การดำเนินงาน",
            importNow: "นำเข้าทันที",
            DataFile: "แฟ้มข้อมูล",
            ClickToUpload: "คลิกเพื่ออัพโหลด",
            TemplateFile: "แฟ้มเทมเพลต",
            clickToDownloadTheMonthlyOrderTemplateFile: "คลิกที่นี่เพื่อดาวน์โหลดไฟล์เทมเพลตคำสั่งรายเดือน",
            clickToDownloadTheSKUOrderTemplateFile: "คลิกเพื่อดาวน์โหลดไฟล์เทมเพลตคำสั่ง SKU",
            importData: "นำเข้าข้อมูล",
            manualUploading: "อัปโหลดด้วยตนเอง",
            Home: "หน้าแรก",
            WhatSon: "กิจกรรม",
            Rewards: "รางวัล eXtra",
            Module: "โมดูล",
            TechWiki: "ข่าวสารยานยนต์",
            MyAccount: "บัญชีของฉัน",
            BOSCHAZPortal: "ลูกค้า Bosch Autoparts",
            YourApplicationIsPendingReview: "ใบสมัครของคุณอยู่ระหว่างการตรวจสอบ",
            CorporateInformation: "ข้อมูลบริษัท",
            LegalNotice: "ประกาศทางกฎหมาย",
            DataProtectionPolicy: "นโยบายการคุ้มครองข้อมูล",
            PrivacySettings: "การตั้งค่าความเป็นส่วนตัว",
            RobertBoschGmbH: "© 2021 - 2025 Robert Bosch GmbH, all rights reserved",
            // 选择国家页:",",
            SelectCountry: "เลือกประเทศ",
            WarmingReminderYouCanOnlyAccessMalyssiaNow: "ปัจจุบันมีเพียงแพลตฟอร์มมาเลเซียของเราเท่านั้นที่สามารถเข้าถึงได้  โปรดติดตามการอัพเดตอีกครั้ง!",
            // 添加员工:",",
            AddEmployee: "เพิ่มพนักงาน",
            FillInEmployeeInfo: "กรอกข้อมูลพนักงาน",
            SheHeIs: "เธอ/เขาคือ....",
            YourApplicationIsAentToYourTheOwnerOfYourCompanyForApproval: "ใบสมัครของคุณอยู่ระหว่างการตรวจสอบ",
            // 表单:",",
            Registration: "การลงทะเบียน",
            Step1: "ขั้นตอนที่ 1",
            Step2: "ขั้นตอนที่ 2",
            MobileNo: "หมายเลขโทรศัพท์มือถือ",
            FirstName: "ชื่อ",
            LastName: "นามสกุล",
            CompanyName: "ชื่อบริษัท",
            Email: "อีเมล",
            EmailOptional: "อีเมล",
            FullAddress: "ที่อยู่เต็ม",
            Address: "ที่อยู่เต็ม",
            City: "เมือง",
            PleaseEnter: "กรุณากรอกรหัส",
            ProvinceState: "จังหวัด/รัฐ",
            ZipCode: "รหัสไปรษณีย์",
            Continue: "ต่อไป",
            Step3: "ขั้นตอนที่ 3",
            IAmA: "ฉันเป็น......",
            IAm: "ฉันเป็น......",
            RepairSegment: "ส่วนซ่อม",
            VehicleSegment: "กลุ่มยานพาหนะ",
            PreferredDistributor: "ผู้จัดจําหน่ายที่ต้องการ",
            Workshop: "อู่รถยนต์",
            Retailer: "ร้านค้าปลีก",
            TradeLevel: "ช่องทางการจำหน่ายสินค้า",
            PortalId: "รหัสพอร์ทัล",
            Distributor: "ผู้แทนจําหน่าย",
            Diesel: "เครื่องยนต์ดีเซล",
            Gasoline: "ระบบแก๊สโซลีน",
            OthersEV: "อื่นๆ (EV)",
            Motorcycle: "จักรยานยนต์",
            PassengerCars: "รถยนต์นั่งส่วนบุคคล",
            TrucksBus: "รถบรรทุก/รถบัส",
            NoOfWorkbay: "จำนวนช่องซ่อม",
            FillIn: "กรอก",
            Namecard: "นามบัตร",
            TakeNamecard: "รับนามบัตร",
            CompanyShopfront: "หน้าร้านของบริษัท",
            PleaseUploadYourCompanyNamecard: "โปรดอัปโหลดนามบัตรบริษัทของคุณ",
            TakePhotoOfCompanyShopfront: "ถ่ายรูปหน้าร้านของบริษัท",
            PleaseUploadYourCompanyShopfront: "โปรดอัปโหลดหน้าร้านของบริษัทของคุณ",
            SignUpForEXtraProgram: "ลงทะเบียนสําหรับโปรแกรม eXtra",
            PleaseCheckAgain: "โปรดตรวจสอบอีกครั้ง!,",
            IsTheGivenInformationCorrect: "ข้อมูลที่ให้มาถูกต้องหรือไม่?",
            DoYouAgreeOurPrivacyPolicy: "คุณเห็นด้วยกับนโยบายความเป็นส่วนตัวของเราหรือไม่?",
            DoYouAgreeOurTermsConditions: "คุณเห็นด้วยกับข้อกําหนดและเงื่อนไขของเราหรือไม่?",
            ConfirmToRegister: "การลงทะเบียน",
            PleaseCheckIfTBD: "โปรดตรวจสอบว่าข้อมูลที่ให้มาถูกต้องหรือไม่?",
            Back: "ย้อนกลับ",
            Confirm: "ยืนยัน",
            PleaseCheckIfTheGivenInformationIsCorrect: "โปรดตรวจสอบว่าข้อมูลที่ให้มาถูกต้องหรือไม่?",
            PleaseEnterTheRequiredInfo: "กรุณากรอกข้อมูลที่จําเป็น",
            pleaseMakeSureIfYouWannaSignUpForEXtraProgram: "โปรดตรวจสอบให้แน่ใจว่าคุณต้องการลงทะเบียนโปรแกรม eXtra,",
            AlreadySubmittedPendingApproval: "ส่งแล้ว รอการอนุมัติ!",
            OwnerMobileNo: "เบอร์โทรศัพท์มือถือ",
            Manager: "ผู้จัดการ",
            Employee: "ลูกจ้าง",
            Owner: "นายจ้าง",
            RequestANewOTP: "ขอรหัส OTP ใหม่",
            YouHaveSelectdSMSAsNotificationChannel: "คุณได้เลือก SMS เป็นช่องทางการแจ้งเตือน คุณจะได้รับ OTP ไปยังหมายเลขโทรศัพท์มือถือที่คุณให้ไว้ในไม่ช้า กรุณากรอก OTP เพื่อลงทะเบียนให้เสร็จสมบูรณ์",
            DataProtectionGuidelines: "นโยบายการคุ้มครองข้อมูล",
            GeneralTermsConditions: "ข้อกําหนดและเงื่อนไขทั่วไป",
            PleaseEnterYourPhoneNumber: "ต้องใช้หมายเลขโทรศัพท์มือถือ!",
            CellPhoneNumberIsRequired: "ต้องใช้หมายเลขโทรศัพท์มือถือ!",
            pleaseAgreeOurTermsAndConditions: "โปรดยอมรับข้อกําหนดและเงื่อนไขของเรา",
            pleaseAgreeOurDataProtectionPolicy: "โปรดยอมรับนโยบายการคุ้มครองข้อมูลของเรา",
            pleaseAgreeOurLegalNotice: "โปรดยอมรับประกาศทางกฎหมายของเรา",
            PleaseChooseYourRegion: "โปรดเลือกภูมิภาคของคุณ",
            PleaseEnterOTP: "กรุณากรอกรหัส OTP",
            LoginToProceed: "เข้าสู่ระบบเพื่อดําเนินการต่อ",
            Login: "เข้าสู่ระบบ",
            RegisterNow: "ลงทะเบียนเลย",
            DontHaveAnAccount: "ไม่มีบัญชี",
            OTP: "รหัส OTP",
            RequestANewOTP: "ขอรหัส OTP ใหม่",
            YourApplicationIsPendingApproval: "ใบสมัครของคุณอยู่ระหว่างการอนุมัติโปรดรอสักครู่!",
            success: "ความสําเร็จ!",
            rule_list: "ประวัติ",
            AccountData: "ข้อมูลบัญชี",
            CountryRegion: "ประเทศ / ภูมิภาค",
            Role: "บทบาทงาน",
            ModifyBasicInformation: "ภาพถ่าย บริษัท",
            PleaseFillInYourEmail: "อีเมลของคุณไม่ถูกต้องในรูปแบบโปรดป้อนอีกครั้ง!",
            CompanyData: "ข้อมูลบริษัท",
            eXtraID: "รหัส eXtra",
            ModifyInformation: "แก้ไขข้อมูล",
            ModifyKeyInformation: "แก้ไขข้อมูลสําคัญ",
            ChangeCompanyPhoto: "เปลี่ยนรูปบริษัท",
            LogOut: "ออกจากระบบ",
            NoDataAvailable: "ไม่มีข้อมูล",
            Search: "ค้นหา",
            Modify: "แก้ไข",
            PleaseCheckTheDataProtectionPolicyAndLegalNotice: "โปรดตรวจสอบนโยบายการคุ้มครองข้อมูลและประกาศทางกฎหมาย!,",
            // 人员管理:",",
            RoleManagement: "การจัดการบทบาท",
            Time: "เวลา",
            Refuse: "ปฏิเสธ",
            Accept: "ยอมรับ",
            DoYouConfirmToApproveIt: "คุณยืนยันที่จะอนุมัติหรือไม่?",
            DoYouConfirmToRejectIt: "คุณยืนยันที่จะปฏิเสธหรือไม่?",
            PleaseConfirmAgain: "การแจ้งเตือน",
            RoleInformation: "ข้อมูลเพิ่มเติม",
            Name: "ชื่อ",
            Activate: "เปิดบัญชี",
            Disable: "ปิดบัญชี",
            IdentitySettings: "การตั้งค่าข้อมูลส่วนตัว",
            DoYouConfirmToChangeThisInformation: "คุณยืนยันที่จะเปลี่ยนแปลงข้อมูลนี้หรือไม่?",
            DoYouConfirmToActivateThisAccount: "คุณยืนยันที่จะเปิดใช้งานบัญชีนี้หรือไม่?",
            DoYouConfirmToDisableThisAccount: "คุณยืนยันที่จะปิดใช้งานบัญชีนี้หรือไม่?",
            // article:",",
            PurchaseRecord: "บันทึกการซื้อ",
            TotalPurchase: "ยอดคำสั่งซื้อ",
            valueSGD: "มูลค่า (บาท)",
            TotalPurchaseValue: "มูลค่าการซื้อทั้งหมด",
            TotalPurchaseAmt: "จำนวนทั้งหมด",
            ProcurementRecords: "ประวัติคำสั่งซื้อ",
            View: "ภาพรวม",
            LatestArticles: "บทความล่าสุด",
            LearnMore: "ศึกษาเพิ่มเติม >",
            // Autoparts:",",
            AutoParts: "อะไหล่รถยนต์",
            ViewMore: "ดูเพิ่มเติม >",
            BoschGroup: "Bosch Group",
            BoschMobilityAftermarket: "Bosch ฝ่ายอะไหล่รถยนต์",
            // BSSList:",",
            WelcomeBoschModulePartner: "ยินดีต้อนรับพันธมิตรModule!",
            MyBenefits: "สิทธิประโยชน์ของฉัน >",
            MoreInfoAboutModule: "ข้อมูลเพิ่มเติมเกี่ยวกับModule >",
            AnnualPartsTarget: "เป้าหมายประจําปี",
            StillToGo: "เป้าหมายที่ต้องไปถึง",
            ContractTarget: "เป้าหมายสัญญา",
            TotalAchievement: "ความสําเร็จทั้งหมด",
            Year: "ปี",
            ActualSales: "ยอดขายจริง",
            ContractPeriod: "ระยะเวลาสัญญา,",
            years: "ปี",
            JoinDate: "วันที่เริ่มต้นสัญญา",
            KeepUpTheGreatProgress: "ติดตามความคืบหน้า",
            DealerWillGetInTouchWithYouSoon: "ตัวแทนจําหน่ายจะติดต่อคุณในภายหลัง",
            ViewMyContract: "ดูสัญญาของฉัน",
            Marketing: "การตลาด",
            promotionZone: "โซนโปรโมชั่น",
            Attended: "กำลังดำเนินการ",
            Achieved: "0",
            Received: "ยอมรับ",
            Done: "0",
            Abandoned: "ปฏิเสธ",
            to: "ถึง",
            CurrentPurchase: "คำสั่งซื้อล่าสุด",
            SGD: "บาท",
            MarketingPromotionZone: "โปรโมชั่นสินค้า",
            NotAttended: "ไม่มีบริการ",
            // contact_us:",",
            Like: "ชอบ",
            Comment: "ติชม",
            SaySometihing: "ติดต่อเรา",
            Sending: "ส่ง",
            User: "0",
            PleaseTypeWords: "กรอกที่นี่",
            AutomotiveTech: "เทคโนโลยียานยนต์",
            views: "จำนวนผู้เข้าชม",
            // Home:",",
            FunctionalityInDevelopment: "ฟังก์ชันกำลังพัฒนา",
            // Module:",",
            Apply: "สมัคร",
            JoinUsLogIn: "เข้าร่วมกับเรา / เข้าสู่ระบบ",
            JoinUs: "เข้าร่วมกับเรา",
            BoschModuleConcept: "แนวคิดโมดูลของ Bosch",
            IHaveReadAndAcceptedTheBoschModulePolicy: "ฉันได้อ่านและยอมรับนโยบายโมดูลของ Bosch แล้ว",
            SignNow: "ลงชื่อเลย",
            PleaseFillInTheBelowArea: "กรุณากรอกข้อมูลในส่วนด้านล่าง",
            PleaseFillInYourFirstNameUnrecognizedOrIncorrectSignatureWillLeadToRegistrationFailure: "คำเตือน กรุณากรอกชื่อของคุณให้ถูกต้อง",
            PlaeaseFillInYourFirstName: "กรอกชื่อของคุณ",
            pleaseCheckTheBoschModulePolicy: "โปรดตรวจสอบนโยบายโมดูลของ Bosch",
            KindlyProvideSignatureOrFullName: "กรุณาระบุลายเซ็นหรือชื่อ-นามสกุล",
            // MyAccount:",",
            loggedInSuccessfully: "สําเร็จ!",
            IAlreadyHaveAnOTP: "ฉันมีรหัส OTP อยู่แล้ว",
            Tel: "หมายเลขโทรศัพท์มือถือ",
            PendingIdentityForReview: "อยู่ในขั้นตอนการตรวจสอบ",
            EnterBoschModuleTiering: "เข้าสู่การจัดระดับโมดูลของ Bosch >",
            CurrentMember: "สมาชิกปัจจุบัน",
            EarnPointsEveryDay: "รับคะแนนทุกวัน",
            eXtraMall: "eXtra Mall",
            eXtraPoints: "คะแนน eXtra",
            eXtraPoint: "คะแนน eXtra",
            Go: "ไป",
            Redeem: "แลกของรางวัล",
            MyServices: "บริการของฉัน",
            eXtra: "eXtra",
            Order: "คำสั่งซื้อ",
            Points: "คะแนน",
            Details: "ราย ละเอียด",
            Personal: "ข้อมูลส่วนบุคคล",
            Data: "ข้อมูล",
            Privacy: "ความเป็นส่วนตัว",
            Clause: "อนุประโยค",
            PersonalData: "ข้อมูลส่วนบุคคล",
            eXtraWokrshopCandidate: "รอการเป็นสมาชิก",
            KevinCarRepairServiceCenter: "-",
            MoreInfoAboutCompany: "ข้อมูลเพิ่มเติมเกี่ยวกับ บริษัท",
            MoreInfoAboutYou: "ข้อมูลเพิ่มเติมเกี่ยวกับคุณ",
            MyFirstName: "ชื่อของฉัน",
            MyLastName: "นามสกุลของฉัน",
            BossMobileNumber: "หมายเลขโทรศัพท์มือถือของคุณ",
            // Recordltem:",",
            time: "เวลา",
            item: "รายการ",
            Qty: "จำนวน",
            PN: "เบอร์สินค้า",
            dealer: "ตัวแทนจําหน่าย",
            Download: "ดาวน์โหลด",
            // Rewards:"งวัล,",
            expiresOn: "หมดอายุวันที่",
            ActivityRules: "รายละเอียดกิจกรรม",
            CheckInDone: "เช็คอินเสร็จแล้ว",
            CheckInNOW: "เช็คอินตอนนี้",
            ThePointsDataWillUpdateMonthlyPleaseStayInformedWithUs: "ข้อมูลคะแนนจะได้รับการอัปเดตทุกเดือนโปรดติดตาม!",
            // Video:",",
            FoundTheQRCode: "พบรหัส QR",
            PleaseUseYourMobilePhoneToLog: "โปรดใช้โทรศัพท์มือถือของคุณเพื่อเข้าสู่ระบบเพื่อสแกนผลิตภัณฑ์ให้สําเร็จ!",
            PleaseAllowAuthorizedUseOfYourPhone: "โปรดอนุญาตให้ใช้กล้องโทรศัพท์ของคุณและสแกนอีกครั้ง!",
            // WhatsOn:",",
            ThoEvontTeasorGroupOllors: "มีอะไรใหม่ใน Bosch",
            //刘新增 10/10:",",
            ModuleJoinData: "ข้อมูล Module",
            ViewMyContract: "ดูสัญญาของฉัน",
            NoContractHint: "เรายังไม่ได้สอบถามเกี่ยวกับสัญญาของคุณ โปรดติดต่อฝ่ายขายบ๊อชของคุณ",
            NoticeOfExpirationOfContract: "สัญญาของคุณหมดอายุแล้ว! โปรดรอให้บ๊อชจัดการต่อสัญญา",
            ChannelPromotion: "ช่องทางโปรโมชั่น",
            OK: "โอเค",
            Congratulations: "ขอแสดงความยินดี",
            YouHaveAchievedTheTarget: "คุณบรรลุเป้าหมายแล้ว",
            PleaseAwaitBoschArrangementForYourEntitlement: "โปรดรอจนกว่าบ๊อชจะจัดเตรียมสิทธิ์ของคุณ!",
            ReceivedTheRewards: "ได้รับรางวัลแล้ว",
            NotYetReceived: "ยังไม่ได้รับ",
            // (10/12):",",
            WorkRole: "บทบาทการทำงาน",
            ICanNotFindMyDistributor: "ไม่พบตัวแทนจำหน่าย",
            AllAutoparts: "ทั้งหมด",
            BatterySpecialist: "แบตเตอรี่ที่เกี่ยวข้อง",
            Others: "อื่นๆ",
            Cancel: "การยกเลิก",
            PleaseEnterTheCorrectCompanyNameAndMobileNumber: "กรุณากรอกชื่อบริษัทและหมายเลขโทรศัพท์มือถือที่ถูกต้อง",
            ALL: "ทั้งหมด",
            AccessOurFullRangeOfAvailableProductsOnTheGoSimplyClickOnYourProductGroupOfInterestToDiveIn: "เข้าถึงผลิตภัณฑ์ที่หลากหลายของเราได้ทุกที่ทุกเวลา - เพียงแค่คลิกที่กลุ่มผลิตภัณฑ์ที่คุณสนใจเพื่อดูข้อมูลเชิงลึก!",
            searchPartnumberItem: "ค้นหาหมายเลขสินค้า ชื่อสินค้า",
            searchPartnumberDealer: "ค้นหาหมายเลขสินค้า, ตัวแทนจำหน่าย",
            Send: "ส่ง",
            Submit: "ส่ง",
            BoschAutopartsCustomerPortal: "",
            //(10/14):",",
            Reset: "รีเซ็ต",
            SelectAlanguage: "เปลี่ยนภาษา",
            NotFilled: "ไม่มีข้อมูล",
            Yes: "ใช่",
            NO: "ไม่",
            StartTime: "เวลาเริ่มต้น",
            EndTime: "เวลาสิ้นสุด",
            Product: "ผลิตภัณฑ์",
            PendingApproval: "เพื่อตรวจสอบ",
            AuditRejection: "การตรวจสอบไม่ผ่าน",
            registered: "ใช้งานอยู่",
            ResignedDisabled: "ปิดการใช้งาน / ออกจากงาน",
            frozen: "แช่แข็ง",
            PleaseRnterYourLoginAccount: "ยื่นใบสมัครที่ร้านซ่อมบำรุงแล้วแจ้งให้เจ้านายทราบ",
            AddEmployee: "เพิ่มพนักงาน",
            ViewDetails: "ดูรายละเอียด",
            YourRegistrationApplicationIsCurrentlyUnderReview: "ขณะนี้อยู่ระหว่างการตรวจสอบใบสมัคร",
            IHaveTakenNoteOfThe: "ผมสังเกตเห็น",
            DataProtectionNotice: "ประกาศการคุ้มครองข้อมูล",
            ContactUs: "ติดต่อเรา",
            YourDetails: "รายละเอียดของคุณ",
            InquiryDetails: "สอบถามรายละเอียด",
            Description: "คำอธิบาย",
            Subject: "หัวข้อ",
            ModulesSignUp: "การลงทะเบียนโมดูล",
            PleaseFillInAllTheRequiredInformation: "กรุณากรอกข้อมูลที่จำเป็นทั้งหมด!",
            Expired: "หมดอายุ",
            PleaseAccessThroughMobileBrowser: "กรุณาเข้าเบราว์เซอร์โทรศัพท์มือถือ",
            Enter: "เข้า",
            Partnership: "ความร่วมมือ",
            EGGMALL: "เอ็ก มอลล์",
            CreateTheEGGMallAccount: "สร้างบัญชี EGG Mall",
            Egg_hint: "คุณจะอนุญาตให้เราใช้ข้อมูลของคุณเพื่อสร้างบัญชี Egg Mall ซึ่งจะผูกกับบัญชีของเรา.",
            IAccept: "I ยอมรับ",
            Egg_check_Policy: "《นโยบายความเป็นส่วนตัวของ EGG Mall》",
            ConfirmToCreate: "ยืนยันการสร้าง",
            PleaseCheckAndAcceptThePrivacyPolicy: "โปรดตรวจสอบและยอมรับนโยบายความเป็นส่วนตัว",
            CreationComplete: "สร้างเสร็จสมบูรณ์",
            OverallAnnualBoshPurchase: "การซื้อของ Bosch ทั้งปี",
            // 勋章活动:",",
            WelcomeToTheBoschBusinessPortal: "ยินดีต้อนรับสู่พอร์ทัลธุรกิจ Bosch!",
            TBBPBAEFTOIOPJFYAABC: "พอร์ทัลธุรกิจ Bosch นำฟังก์ชั่นที่สำคัญทั้งหมดมารวมกันในสถานที่เดียวเพียงสําหรับคุณในฐานะลูกค้า Bosch",
            TakeOurTourAndDiscoverWhatsInside: "ไปทัวร์ของเราและค้นพบอะไรอยู่ภายใน!",
            StartTour: "เริ่มทัวร์",
            medalLayer1_head: "กระเบื้องนี้จะพาคุณไปยังเรา",
            medalLayer1: "แคตตาล็อกอิเล็กทรอนิกส์",
            medalLayer1_tail: "ที่คุณสามารถค้นหาและกรองผลิตภัณฑ์ Bosch ทั้งหมดที่มีอยู่ในประเทศของคุณ",
            medalLayer2_head: "สำรวจของเรา",
            medalLayer2: "",
            medalLayer2_tail: "เพื่อติดตามบทความล่าสุดและความเข้าใจจากจักรวาล Bosch",
            medalLayer3_head: "",
            medalLayer3: "รหัสสมาร์ท",
            medalLayer3_tail: "ช่วยให้คุณเข้าใจผลิตภัณฑ์ Bosch ของเราได้ดีขึ้นและสามารถพบได้ในผลิตภัณฑ์ Bosch แท้ของเรา สแกนรหัส QR บนอุปกรณ์มือถือของคุณเพื่อหาข้อมูลเพิ่มเติม!",
            medalLayer3_btn: "อุปกรณ์มือถือ",
            medalLayer4_head: "กระเบื้องนี้พาคุณไปยัง",
            medalLayer4: "eXtra รางวัล",
            medalLayer4_tail: "เมนู, ที่คุณสามารถตรวจสอบความสมดุลคะแนนปัจจุบันของคุณ, สแกนผลิตภัณฑ์เพื่อรับคะแนนมากขึ้น, และอื่น ๆ อีกมากมาย!",
            medalLayer5_head: "คลิกที่",
            medalLayer5: "เทคโนโลยีรถยนต์",
            medalLayer5_tail: "กระเบื้องเพื่อไปที่ห้องสมุดของวิดีโอกวดวิชาของเราและเรียนรู้เกี่ยวกับผลิตภัณฑ์ของเรา",
            medalLayer6_head: "เคยสงสัยเกี่ยวกับ",
            medalLayer6: "โปรแกรม Bosch Module",
            medalLayer6_tail: "ค้นหาข้อมูลเพิ่มเติมโดยคลิกที่กระเบื้องนี้!",
            FinishTour: "ทัวร์เสร็จสิ้น",
            Step: "ขั้นตอน",
            ofTo: "ของ",
            HallOfFame: "ห้องโบราณชื่อเสียง",
            BadgeEarned: "ป้ายที่ได้รับ",
            AvailableChallenges: "ความท้าทายที่มีอยู่",
            StartChallenge: "เริ่มท้าทาย",
            ContinueChallenge: "ความท้าทายต่อไป",
            AvailableBadges: "ป้ายที่มีอยู่",
            FeedbackSurvey: "การสำรวจความคิดเห็น",
            medal_form_1: "ตอนนี้ที่คุณได้เห็นส่วนใหญ่ของ Bosch Business Portal แล้ว เราสนใจความคิดเห็นของคุณ!",
            medal_form_2: "คุณให้คะแนน Bosch Business Portal อย่างไร",
            medal_form_3: "(1-5 ดาว)",
            medal_form_4: "คุณสมบัติที่คุณชื่นชอบของพอร์ทัลคืออะไร?",
            medal_form_5: "แคตตาล็อกอิเล็กทรอนิกส์",
            medal_form_6: "Modules ส่วน",
            medal_form_7: "สารานุกรมเทคโนโลยี",
            medal_form_8: "ข่าว",
            medal_form_9: "ป้องกันปลอม",
            medal_form_10: "มีความคิดเห็นอื่น ๆ ไหม?",
            medal_form_11: "เรารอคอยรับความคิดเห็นของคุณ โปรดใส่ใด ๆ!",
            BadgeLeaderboard: "ป้ายคณะกรรมการผู้นำ",
            TheRankWillBeUpdatedByDay: "อันดับจะถูกปรับปรุงตามวัน",
            AchievedTime: "เวลาที่บรรลุ",
            MyRank: "อันดับของฉัน",
            ContinueToComplete: "ต่อเสร็จ",
            YouJustGotEXtraPointsRewardsRorCompleting: "คุณเพิ่งประสบความสำเร็จ",
            YouJustGotEXtraPointsRewardsRorCompleting2: "และได้รับคะแนน eXtra!",
            YouJustEarnedBadge: "คุณเพิ่งได้รับป้าย",
            Collect: "เก็บรวบรวม",
            FirstSteps: "ขั้นตอนแรก",
            andPleaseKeepGoingOn: "และโปรดดําเนินการต่อไป!",
            Welcome: "ยินดีต้อนรับ",
            Welcome2: "ยินดีต้อนรับสู่พอร์ทัลธุรกิจ Bosch!",
            layer2hint1: "ขอบคุณที่เลือก Bosch คลิกที่ปุ่มด้านล่างเพื่อดูวิธีการที่คุณสามารถท้าทายที่น่าตื่นเต้นได้ รับคะแนน eXtra และรับป้ายด้านล่าง!",
            layer2hint2: "ห้องโบราณชื่อเสียง",
            layer2hint3: "ที่คุณสามารถรับป้ายและคะแนน eXtrapoints ได้ตลอดทางโดยเสร็จสิ้นการท้าทาย",
            ContinueToExplore: "สํารวจต่อไป",
            TakeMeThere: "พาผมไปที่นั่น!   ",
            medal_form_list_1: "เวลาที่บรรลุ",
            stepType5Hint: "กรุณาบรรลุขั้นตอนก่อนหน้านี้ก่อน",
            ContinueToAchieve: "ดำเนินการต่อไป",
            // 25 6/11新增:"0,",
            ConnectYourEXtraAccount: "เชื่อมต่อบัญชี eXtra ของคุณ",
            ConnectYourEXtraAccount2: "กรุณาป้อนบัญชี eXtra และรหัสผ่านของคุณ และเราจะเชื่อมต่อบัญชีพอร์ทัลของคุณกับบัญชี eXtra ของคุณ",
            Account: "บัญชี",
            EnterAccountNo: "ป้อนหมายเลขบัญชี",
            Password: "รหัสผ่าน",
            EnterPassword: "ป้อนรหัสผ่าน",
            Submit: "สุเมธ",
            // 25 5/9新增:"0,",
            SignUp: "ลงทะเบียน",
            LogIn: "เข้าสู่ระบบ",
            LogIn_hint: "สำหรับผู้ใช้ที่มีอยู่แล้ว โปรดเข้าสู่ระบบ สำหรับผู้ใช้ใหม่ กรุณาสมัครสมาชิก ขอบคุณ!",
            LogIn_hint2: "สำหรับผู้ใช้ที่มีอยู่แล้ว โปรดเข้าสู่ระบบ สำหรับผู้ใช้ใหม่ กรุณาสมัครสมาชิก ขอบคุณ!",
            LogIn_hint2_1: "ผู้ใช้ใหม่ กรุณาสมัครสมาชิก ขอบคุณ!",
            WelcomeToBoschBusinessPortal: "ยินดีต้อนรับสู่ Bosch Business Portal",
            WelcomeTo: "ยินดีต้อนรับสู่,",
            BoschBusinessPortal: "พอร์ทัลธุรกิจ Bosch",
            LogInSuccessfully: "เข้าสู่ระบบสำเร็จ",
            GetYourRewards: "รับรางวัลของคุณ",
            WarmReminder: "คุณสามารถใช้ฟังก์ชันนี้ได้เพียงหลังจากที่คุณผ่านการตรวจสอบ โปรดรอเดี๋ยว!",
            //2025 8/23新增:"0,",
            News_pdates: "อัปเดตข่าวสาร",
            CustomerTrainingsEvents: "การฝึกอบรมและกิจกรรมสำหรับลูกค้า",
            News: "ข่าวสาร",
            Promotion: "โปรโมชั่น",
            E_Magizines: "นิตยสารออนไลน์",
            FileFormat: "รูปแบบไฟล์",
            FindOutMoreHere: "ค้นหาข้อมูลเพิ่มเติมที่นี่",
            AccessPastTrainingsHere: "เข้าถึงการฝึกอบรมที่ผ่านมาที่นี่!",
            AccessCurrentTrainingsHere: "เข้าถึงการฝึกอบรมปัจจุบันที่นี่!",
            BDCHub: "พื้นที่ BDC",
            BDCExcellenceHub: "พื้นที่ BDC",
            BDCtitle: "อัปเดตข่าวสาร",
            BDCcenter: "รับทราบข่าวสารล่าสุดเกี่ยวกับเหตุการณ์และนวัตกรรมจากโลกของ Bosch",
            BDC_AutoPartsTitle: "แคตตาล็อกสินค้าออนไลน์",
            BDC_AutoPartsCenter: "สํารวจพอร์ตโฟลิโอผลิตภัณฑ์ Bosch รวมถึงดีเซลและสายผลิตภัณฑ์อื่น ๆ ด้วยการใช้งานรถยนต์, การอ้างอิงข้าม OE และข้อมูลผลิตภัณฑ์รายละเอีย เพียงคลิกลิงค์ด้านล่างเพื่อสำรวจ.",
            bdcNAV1: "คลังอะไหล่",
            bdcNAV2: "เครื่องมือทดสอบ และซอฟต์แวร์",
            bdcNAV3: "ศูนย์ความเป็นเลิศ BDC",
            bdcNAV4: "ค้นหาเอกสาร",
            CustomerTrainingstext1: "ยินดีต้อนรับสู่โปรแกรมการฝึกอบรมดีเซล",
            CustomerTrainingstext1_center: "Diesel & Beyond เป็นโครงการฝึกอบรมที่สร้างพลังสําหรับเครือข่ายดีเซล Bosch ที่ออกแบบมาเพื่อสร้างความสามารถและเตรียมการประชุมเชิงปฏิบัติการสําหรับการพัฒด้วยหลักสูตรที่ครอบคลุมทั้งออนไลน์และในสถานที่, รูปแบบการเรียนรู้แบบโต้ตอบ, การแนะนำโดยผู้เชี่ยวชาญ, และโอกาสในการรับรอง, มันอุปกรณ์การประชุมเชิงปฏิบัติการด้วยทักษะและความ",
            CustomerTrainingstext1_hint: "",
            CustomerTrainingstext1_btnL: "เข้าถึงการฝึกอบรมที่ผ่านมาที่นี่!",
            CustomerTrainingstext1_btnR: "เข้าถึงการฝึกอบรมปัจจุบันที่นี่!",
            CustomerTrainingstext2: "กิจกรรมสำหรับลูกค้าที่น่าตื่นเต้น",
            CustomerTrainingstext2_center: "เราจัดกิจกรรมลูกค้าที่มีปฏิสัมพันธ์อย่างเป็นประจํ เช่น คืนดีเซลและการประชุม เพื่อให้ติดต่อกับลูกค้าของเรา ในช่วงนี้ คุณสามารถตรวจสอบเหตุการณ์ในอดีตได้อย่างสะดวกสบายด้วยการนำเสนอ รูปภาพ และวัสดุ รวมถึงการค้นพบเหตุการณ์ที่กำลังจะเกิดขึ้นและโอกาสในการสร้างเครื",
            CustomerTrainingstext2_btnL: "เข้าถึงกิจกรรมที่ผ่านมาที่นี่!",
            CustomerTrainingstext2_btnR: "เข้าถึงกิจกรรมปัจจุบันที่นี่!",
            CustomerTrainingsnav1_1: "ระบบเครื่องยนต์ดีเซลคอมมอนเรล",
            CustomerTrainingsnav1_2: "ระบบดีเซลทั่วไป",
            CustomerTrainingsnav1_3: "การบำบัดก๊าซเสีย",
            CustomerTrainingsnav1_4: "ส่วนอื่น ๆ",
            NoDataAvailable2: "ขณะนี้ยังไม่มีโปรโมชั่นที่ถูกต้อง คอยติดตามการอัปเดตต่อไป!",
            // ModuleConcept:"",
            ModuleConcept_text1: "จำนวนใบปัดน้ำฝนที่ต้องซื้อเพิ่มเพื่อรับสิทธิ์ลุ้นรางวัลครั้งถัดไป:",
            ModuleConcept_text2: "ใบ",
            ModuleConcept_text3: "จำนวนสิทธิ์ลุ้นรางวัลที่คุณมี",
            ModuleConcept_text4: "จำนวนใบปัดน้ำฝนที่ซื้อทั้งหมด",
            ModuleConcept_text5: "*ข้อมูลการสั่งซื้อจะอัปเดตทุกเดือน",
            ModuleConcept_text6: "อันดับประจำเดือน",
            ModuleConcept_text7: "月",
            ModuleConcept_text8: "แนะนำกิจกรรมครบรอบ 100 ปี ใบปัดน้ำฝน",

            //Wiper 100:"",
            Wiper_text1: "Wiper 100",
            Wiper_text2: "ครบรอบ 100 ปี ใบปัดน้ำฝน",
            Wiper_text3: "กรุณาตอบคำถามต่อไปนี้ให้ถูกต้องเพื่อเข้าร่วมกิจกรรม!",
            Wiper_text4: "คำถาม: ปีนี้ครบรอบกี่ปีของใบปัดน้ำฝนบ๊อช?",
            Wiper_text5: "A 60",
            Wiper_text6: "B 80",
            Wiper_text7: "C 100",
            Wiper_text8: "D 120",
            Wiper_text9: "ลุ้นเข้าร่วมทริปท่องเที่ยว!",
            Wiper_text11: "หมุนวงล้อรับรางวัล",
            Wiper_text13: "ร่วมฉลองครบรอบ 100 ปีใบปัดน้ำฝนกับบ๊อช",
            Wiper_text14: "หมุนวงล้อเพื่อรับคะแนน!",
            Wiper_text15_1: "คุณสะสมได้แล้ว",
            Wiper_text15_2: "ตัวอักษร! ",
            Wiper_text15_3: " เข้าสู่ระบบอีกครั้งเพื่อปลดล็อกวลีด้านล่าง และลุ้นรับรางวัลใหญ่!",
            Wiper_text16: "Your Lucky Cards",
            Wiper_text17: "ถูกต้อง! ร่วมฉลองครบรอบ 100 ปี ใบปัดน้ำฝนกันเลย!",
            Wiper_text18: "คำตอบไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง!",
            Wiper_text19: "การ์ดที่คุณสะสม",
            Wiper_text20: "ตู้สล็อต",
            Wiper_text21_1: "โหมดปกติ (รางวัลสูงสุด",
            Wiper_text21_2: " คะแนน)",
            Wiper_text22: "สิทธิ์หมุนคงเหลือ",
            Wiper_text23: "หมุน",
            Wiper_text24: "เก็บตัวอักษรใหม่แล้ว",
            Wiper_text25: "ขอแสดงความยินดีกับการได้รับรางวัล",
            Wiper_text26: "คุณได้รับแล้ว",
            Wiper_text27: "โอกาสในการจับรางวัลที่เหลืออยู่ในวันนี้",
            Wiper_text28: " คะแนน",
            Wiper_text29: "ขอโทษด้วยคุณยังไม่ได้รับรางวัล กรุณาลองอีกครั้ง!",
            Wiper_text30: "คาดว่าจะอัปเดตในเดือนเมษายน โปรดรอสักครู่!",
            Wiper_text31: "",


        }
    },
    my: {
        // 马来西亚
        message: {
            PleaseCheckTheSignUpForEXtraProgram: "请勾选并同意注册eXtra平台！",
            monthlyOrderImport: "导出月度订单",
            SKUOrderImport: "导入SKU订单",
            FileCode: "文件编号",
            FileName: "文件名",
            OrderMonth: "订单月份",
            importTime: "导入时间",
            Operate: "操作",
            importNow: "立即导入",
            DataFile: "数据文件",
            ClickToUpload: "点击上传",
            TemplateFile: "模板文件",
            clickToDownloadTheMonthlyOrderTemplateFile: "点击下载《月度订单模板文件》",
            clickToDownloadTheSKUOrderTemplateFile: "点击下载《SKU订单模板文件》",
            importData: "导入数据",
            manualUploading: "手动上传",
            Home: "首页",
            WhatSon: "资讯",
            Rewards: "奖励",
            Module: "Module",
            TechWiki: "技术百科",
            MyAccount: "我的账号",
            BOSCHAZPortal: "Bosch Business Portal",
            YourApplicationIsPendingReview: "你的申请正在审核中。",
            CorporateInformation: "公司信息",
            LegalNotice: "法律声明",
            DataProtectionPolicy: "数据保护政策",
            PrivacySettings: "隐私设置",
            RobertBoschGmbH: "©2025 版权所有 罗伯特·博世有限公司 保留所有权利",
            // 选择国家页:",",
            SelectCountry: "选择国家",
            WarmingReminderYouCanOnlyAccessMalyssiaNow: "您目前无法访问该国家，即将开放敬请期待！",
            // 添加员工:",",
            AddEmployee: "添加员工",
            FillInEmployeeInfo: "填写员工信息",
            SheHeIs: "她/他是",
            YourApplicationIsAentToYourTheOwnerOfYourCompanyForApproval: "您的申请已递交给您所选公司的拥有者。",
            // 表单:",",
            Registration: "注册流程",
            Step1: "第1步骤",
            Step2: "第2步骤",
            MobileNo: "手机号码",
            FirstName: "名字",
            LastName: "姓氏",
            CompanyName: "公司名称",
            Email: "邮箱",
            EmailOptional: "邮箱",
            FullAddress: "详细地址",
            Address: "地址",
            City: "城市",
            PleaseEnter: "请输入",
            ProvinceState: "省份/州/邦",
            ZipCode: "邮编",
            Continue: "下一步",
            Step3: "第3步骤",
            IAmA: "我是…...",
            IAm: "我是……",
            RepairSegment: "维修站类型",
            VehicleSegment: "车型细分",
            PreferredDistributor: "首选经销商",
            Workshop: "维修站",
            Retailer: "分销商",
            TradeLevel: "客户类型",
            PortalId: "Portal ID",
            Distributor: "经销商",
            Diesel: "柴油",
            Gasoline: "汽油",
            OthersEV: "其他（新能源车）",
            Motorcycle: "摩托车",
            PassengerCars: "乘用车",
            TrucksBus: "卡车/公交车",
            NoOfWorkbay: "工位数量",
            FillIn: "填写",
            Namecard: "名片",
            TakeNamecard: "拍摄名片",
            CompanyShopfront: "公司门头",
            PleaseUploadYourCompanyNamecard: "请上传你的公司名片",
            TakePhotoOfCompanyShopfront: "拍摄公司门头",
            PleaseUploadYourCompanyShopfront: "请上传你的公司门头",
            SignUpForEXtraProgram: "注册eXtra会员",
            PleaseCheckAgain: "请再次确认。",
            IsTheGivenInformationCorrect: "请问所提供信息是否正确？",
            DoYouAgreeOurPrivacyPolicy: "请问您同意我们的隐私政策吗？",
            DoYouAgreeOurTermsConditions: "请问您同意我们的使用条款吗？",
            ConfirmToRegister: "确认注册",
            PleaseCheckIfTBD: "请您确认所提供信息是否正确！",
            Back: "返回",
            Confirm: "确认",
            PleaseCheckIfTheGivenInformationIsCorrect: "请您确认所提供信息是否正确！",
            PleaseEnterTheRequiredInfo: "请输入必填信息。",
            pleaseMakeSureIfYouWannaSignUpForEXtraProgram: "请您确认是否要同步注册eXtra会员。",
            AlreadySubmittedPendingApproval: "申请已提交，正在审核中。",
            OwnerMobileNo: "老板手机号码",
            Manager: "经理",
            Employee: "员工",
            Owner: "负责人",
            RequestANewOTP: "请输入新的验证码。",
            YouHaveSelectdSMSAsNotificationChannel: "您已选择短信作为通知方式。您所提供的手机号码将收到1条验证码短信。请输入该验证码用以完成注册。",
            DataProtectionGuidelines: "数据保护指南",
            GeneralTermsConditions: "使用条款",
            PleaseEnterYourPhoneNumber: "请您输入手机号码。",
            CellPhoneNumberIsRequired: "手机号码是必填项。",
            pleaseAgreeOurTermsAndConditions: "请您确认我们的使用协议。",
            pleaseAgreeOurDataProtectionPolicy: "请您确认我们的数据保护政策。",
            pleaseAgreeOurLegalNotice: "请您确认我们的法律声明。",
            PleaseChooseYourRegion: "请您选择你所在地区。",
            PleaseEnterOTP: "请你输入验证码。",
            LoginToProceed: "登录",
            Login: "登录",
            RegisterNow: "立即注册",
            DontHaveAnAccount: "未找到该账号",
            OTP: "验证码",
            RequestANewOTP: "请输入新的验证码。",
            YourApplicationIsPendingApproval: "您的申请正在审核中，请耐心等待！",
            success: "成功！",
            rule_list: "历史版本",
            AccountData: "账号信息",
            CountryRegion: "国家/地区",
            Role: "角色",
            ModifyBasicInformation: "公司图片",
            PleaseFillInYourEmail: "您邮箱格式不正确，请重新输入！",
            CompanyData: "公司信息",
            eXtraID: "eXtra ID",
            ModifyInformation: "编辑信息",
            ModifyKeyInformation: "编辑关键信息",
            ChangeCompanyPhoto: "更新公司图片",
            LogOut: "登出",
            NoDataAvailable: "未查询到资料",
            Search: "查询",
            Modify: "编辑",
            PleaseCheckTheDataProtectionPolicyAndLegalNotice: "请您确认数据保护政策和法律声明！",
            // 人员管理:",",
            RoleManagement: "角色管理",
            Time: "加入时间",
            Refuse: "拒绝",
            Accept: "接受",
            DoYouConfirmToApproveIt: "请问您确认同意吗？",
            DoYouConfirmToRejectIt: "请问您确认拒绝吗？",
            PleaseConfirmAgain: "通知",
            RoleInformation: "角色信息",
            Name: "名称",
            Activate: "激活",
            Disable: "禁用",
            IdentitySettings: "身份设置",
            DoYouConfirmToChangeThisInformation: "请问您确认修改信息吗？",
            DoYouConfirmToActivateThisAccount: "请问您确认激活该账号吗？",
            DoYouConfirmToDisableThisAccount: "请问您确认禁用该账号吗？",
            // article:",",
            PurchaseRecord: "采购记录",
            TotalPurchase: "总采购",
            valueSGD: "金额（新加坡币）",
            TotalPurchaseValue: "总采购金额",
            TotalPurchaseAmt: "总采购数量",
            ProcurementRecords: "采购记录",
            View: "查看",
            LatestArticles: "最新资讯",
            LearnMore: "查看更多 >",
            // Autoparts:",",
            AutoParts: "汽车配件",
            ViewMore: "查看更多 >",
            BoschGroup: "博世集团",
            BoschMobilityAftermarket: "博世汽车售后市场",
            // BSSList:",",
            WelcomeBoschModulePartner: "欢迎博世Module合作伙伴！",
            MyBenefits: "我的权益 >",
            MoreInfoAboutModule: "更多关于Module信息 >",
            AnnualPartsTarget: "年度采购目标",
            StillToGo: "未完成",
            ContractTarget: "合同目标",
            TotalAchievement: "整体达成",
            Year: "年度采购目标",
            ActualSales: "实际销售额",
            ContractPeriod: "合同年限",
            years: "年",
            JoinDate: "合同开始时间",
            KeepUpTheGreatProgress: "请继续保持巨大进步！",
            DealerWillGetInTouchWithYouSoon: "经销商将尽快与您联系。",
            ViewMyContract: "查看我的合同",
            Marketing: "市场",
            promotionZone: "支持活动",
            Attended: "进行中",
            Achieved: "已达成",
            Received: "已领取",
            Done: "完成",
            Abandoned: "已放弃",
            to: "To",
            CurrentPurchase: "当前采购",
            SGD: "新加坡币",
            MarketingPromotionZone: "市场支持活动",
            NotAttended: "不可用",
            // contact_us:",",
            Like: "点赞",
            Comment: "评论",
            SaySometihing: "请输入文案",
            Sending: "发送",
            User: "用户",
            PleaseTypeWords: "请输入文案",
            AutomotiveTech: "技术百科",
            views: "观看量",
            // Home:",",
            FunctionalityInDevelopment: "功能正在开发中。",
            // Module:",",
            Apply: "提交",
            JoinUsLogIn: "加入我们/登录",
            JoinUs: "加入我们",
            BoschModuleConcept: "Bosch module concept",
            IHaveReadAndAcceptedTheBoschModulePolicy: "我已确认并同意博世Module政策。",
            SignNow: "立即签名",
            PleaseFillInTheBelowArea: "请完善以下区域内容。",
            PleaseFillInYourFirstNameUnrecognizedOrIncorrectSignatureWillLeadToRegistrationFailure: "请填写您的名字，若签名无法识别或不正确的话，将导致本次注册申请失败。",
            PlaeaseFillInYourFirstName: "请输入您的名称",
            pleaseCheckTheBoschModulePolicy: "请确认博世Module政策",
            KindlyProvideSignatureOrFullName: "请输入您的全名",
            // MyAccount:",",
            loggedInSuccessfully: "登录成功！",
            IAlreadyHaveAnOTP: "我已收到验证码。",
            Tel: "电话号码",
            PendingIdentityForReview: "申请待审核",
            EnterBoschModuleTiering: "输入博世Module等级",
            CurrentMember: "当前成员",
            EarnPointsEveryDay: "天天赢积分",
            eXtraMall: "eXtra商城",
            eXtraPoints: "eXtra积分",
            eXtraPoint: "eXtra积分",
            Go: "前往",
            Redeem: "兑换",
            MyServices: "我的服务",
            eXtra: "eXtra",
            Order: "订单",
            Points: "eXtra积分",
            Details: "详情",
            Personal: "个人",
            Data: "数据",
            Privacy: "隐私",
            Clause: "条款",
            PersonalData: "个人数据",
            eXtraWokrshopCandidate: "会员",
            KevinCarRepairServiceCenter: "0",
            MoreInfoAboutCompany: "更多公司信息",
            MoreInfoAboutYou: "更多你的信息",
            MyFirstName: "我的名字",
            MyLastName: "我的姓氏",
            BossMobileNumber: "老板手机号码",
            // Recordltem:",",
            time: "加入时间",
            item: "类目",
            Qty: "数量",
            PN: "产品编号",
            dealer: "经销商",
            Download: "下载",
            // Rewards:"0,",
            expiresOn: "0",
            ActivityRules: "活动规则",
            CheckInDone: "已签到",
            CheckInNOW: "立即签到",
            ThePointsDataWillUpdateMonthlyPleaseStayInformedWithUs: "积分数据将以月度频次进行更新，请您耐心等待。",
            // Video:",",
            FoundTheQRCode: "已找到二维码",
            PleaseUseYourMobilePhoneToLog: "请您使用您的手机进行登录以便于进行产品扫码！",
            PleaseAllowAuthorizedUseOfYourPhone: "请您允许手机摄像头的使用权限并再次扫码。",
            // WhatsOn:",",
            ThoEvontTeasorGroupOllors: "0",
            //刘新增 10/10:",",
            ModuleJoinData: "Module加入时间",
            ViewMyContract: "查看我的合同",
            NoContractHint: "我们未找到您的合同，请您联系博世销售。",
            NoticeOfExpirationOfContract: "您的合同已到期！请您等待博世联系续约！",
            ChannelPromotion: "渠道市场支持",
            OK: "好的",
            Congratulations: "恭喜！",
            YouHaveAchievedTheTarget: "您已达成任务目标！",
            PleaseAwaitBoschArrangementForYourEntitlement: "请您耐心等待博世为您发放权益。",
            ReceivedTheRewards: "已收到奖励",
            NotYetReceived: "还未收到",
            // (10/12):",",
            WorkRole: "员工角色",
            ICanNotFindMyDistributor: "未找到我的经销商",
            AllAutoparts: "全产品线",
            BatterySpecialist: "蓄电池专家",
            Others: "其他",
            Cancel: "取消",
            PleaseEnterTheCorrectCompanyNameAndMobileNumber: "请输入正确的公司名称和手机号码",
            ALL: "全部",
            AccessOurFullRangeOfAvailableProductsOnTheGoSimplyClickOnYourProductGroupOfInterestToDiveIn: "随时随地访问我们的全系列可用产品-只需点击您感兴趣的产品组即可深入了解！",
            searchPartnumberItem: "搜索产品料号、产品名称",
            searchPartnumberDealer: "搜索产品料号、经销商",
            Send: "获取验证码",
            Submit: "提交",
    //(10/14):"",
    Reset: ",",
            SelectAlanguage: "重置",
            NotFilled: "切换语言",
            Yes: "无数据",
            NO: "是",
            StartTime: "否",
            EndTime: "开始时间",
            Product: "结束时间",
            PendingApproval: "产品",
            AuditRejection: "待审核",
            registered: "审核不通过",
            ResignedDisabled: "活跃",
            frozen: "禁用/离职",
            PleaseRnterYourLoginAccount: "冻结",
            AddEmployee: "申请已在维修店提交，请通知老板审核",
            ViewDetails: "添加员工",
            YourRegistrationApplicationIsCurrentlyUnderReview: "查看详细信息",
            IHaveTakenNoteOfThe: "您的注册申请目前正在审核中。",
            DataProtectionNotice: "我注意到",
            ContactUs: "数据保护通知",
            YourDetails: "联系我们",
            InquiryDetails: "您的详细信息",
            Description: "查询详情",
            Subject: "描述",
            ModulesSignUp: "主题",
            PleaseFillInAllTheRequiredInformation: "模块注册",
            Expired: "请填写所有必填信息！",
            PleaseAccessThroughMobileBrowser: "到期",
            Enter: "请手机浏览器访问",
            Partnership: "确认",
            EGGMALL: "合作伙伴",
            CreateTheEGGMallAccount: "EGG MALL",
            Egg_hint: "创建EGG MALL平台账号",
            IAccept: "您将授权我们使用您的信息创建Egg Mall帐户，且该Egg Mall帐户将与我们平台的帐户进行绑定。",
            Egg_check_Policy: "我已阅读并同意",
            ConfirmToCreate: "《EGG Mall 隐私政策》",
            PleaseCheckAndAcceptThePrivacyPolicy: "确认创建",
            CreationComplete: "请您阅读并同意隐私政策",
            OverallAnnualBoshPurchase: "创建成功！",
            // 勋章活动:"年度Bosch采购总额",
            WelcomeToTheBoschBusinessPortal: ",",
            TBBPBAEFTOIOPJFYAABC: "Welcome to the Bosch Business Portal!",
            TakeOurTourAndDiscoverWhatsInside: "我们平台专为博世客户提供一站式数字化功能服务。",
            StartTour: "开启你的旅程，快速了解我们",
            medalLayer1_head: "点击开启",
            medalLayer1: "通过这个模块",
            medalLayer1_tail: "e-catalogue",
            medalLayer2_head: "，你可以搜索和筛选所有所属你所在国家可查询的博世产品。",
            medalLayer2: "探索我们的",
            medalLayer2_tail: "news section",
            medalLayer3_head: "来及时了解来自我们博世集团最新的资讯内容",
            medalLayer3: "你可以通过博世产品找到我们博世智码",
            medalLayer3_tail: "Smart Code",
            medalLayer3_btn: "，并通过扫码来获取更多产品信息。",
            medalLayer4_head: "手机设备",
            medalLayer4: "通过这个模块",
            medalLayer4_tail: "eXtra rewards",
            medalLayer5_head: "，你可以查看你最新的易加积分，并通过扫码将获取一定的积分奖励。",
            medalLayer5: "点击",
            medalLayer5_tail: "Automotive tech",
            medalLayer6_head: "模块进入我们的视频百科，了解我们更多产品信息。",
            medalLayer6: "模块进入我们的视频百科，了解我们更多产品信息。",
            medalLayer6_tail: "Bosch Module program",
            FinishTour: "？点击这个模块就能知道！",
            Step: "完成探索旅程",
            ofTo: "步骤",
            HallOfFame: "/",
            BadgeEarned: "成就勋章",
            AvailableChallenges: "已获得",
            StartChallenge: "可达成挑战",
            ContinueChallenge: "开始挑战",
            AvailableBadges: "继续挑战",
            FeedbackSurvey: "已获得勋章",
            medal_form_1: "意见反馈",
            medal_form_2: "您已大致了解了我们的网站功能，非常期待您对目前的体验做出真实的反馈！",
            medal_form_3: "您会为我们的网站打多少分？",
            medal_form_4: "（1-5颗星）",
            medal_form_5: "哪个网站功能是你最喜欢的？",
            medal_form_6: "E-catalogue",
            medal_form_7: "Modules Section",
            medal_form_8: "Auto-Tech",
            medal_form_9: "What's On",
            medal_form_10: "Anti-fake",
            medal_form_11: "其他意见反馈",
            BadgeLeaderboard: "我们非常期待您的反馈，请点击输入......",
            TheRankWillBeUpdatedByDay: "勋章达人榜",
            AchievedTime: "榜单排行将每日更新1次",
            MyRank: "达成时间",
            ContinueToComplete: "我的排行",
            YouJustGotEXtraPointsRewardsRorCompleting: "继续完成",
            YouJustGotEXtraPointsRewardsRorCompleting2: "你已完成挑战",
            YouJustEarnedBadge: "，并且获得相应积分奖励",
            Collect: "你已获得1枚勋章",
            FirstSteps: "收下",
            andPleaseKeepGoingOn: "第1步",
            Welcome: "请继续完成",
            Welcome2: "欢迎",
            layer2hint1: "Welcome to the Bosch Business Portal!",
            layer2hint2: "感谢您选择博世，点击以下按钮了解如何完成当前挑战，并获取相应积分奖励和成就勋章。",
            layer2hint3: "成就勋章",
            ContinueToExplore: "完成任务挑战，获取相应积分奖励，并点亮成就勋章！",
            TakeMeThere: "继续探索",
            medal_form_list_1: "点击前往",
            stepType5Hint: "达成时间：你未获得任何勋章",
            ContinueToAchieve: "请先完成上一步挑战",
            // 25 6/11新增:"点击继续",
            ConnectYourEXtraAccount: "0,",
            ConnectYourEXtraAccount2: "关联你的易加账号",
            Account: "请输入你的易加账号和密码，以便于我们将其与您本网站的账号进行关联。",
            EnterAccountNo: "账号",
            Password: "请输入账号",
            EnterPassword: "密码",
            Submit: "输入密码",
            // 25 5/9新增:"点击提交",
            SignUp: "0,",
            LogIn: "点击注册",
            LogIn_hint: "登录",
            LogIn_hint2: "点击登录已有账号，或者点击注册全新的账号",
            LogIn_hint2_1: "点击登录已有账号",
            WelcomeToBoschBusinessPortal: "或者点击注册全新的账号",
            WelcomeTo: "欢迎来到博世客户端网站",
            BoschBusinessPortal: "Welcome to",
            LogInSuccessfully: "Bosch Business Portal",
            GetYourRewards: "登录成功！",
            WarmReminder: "点击领取奖励",
            //2025 8/23新增:"您当前身份处于审核状态，审核通过后即可使用该功能，请耐心等待！'",
            News_pdates: "0,",
            CustomerTrainingsEvents: "最新资讯",
            News: "客户培训和活动",
            Promotion: "新闻",
            E_Magizines: "促销",
            FileFormat: "电子杂志",
            FindOutMoreHere: "文件格式",
            AccessPastTrainingsHere: "点击查看更多内容。",
            AccessCurrentTrainingsHere: "点击查询历史培训内容！",
            BDCHub: "点击查询当前培训内容！",
            BDCExcellenceHub: "BDC中心",
            BDCtitle: "BDC柴油中心",
            BDCcenter: "最新资讯",
            BDC_AutoPartsTitle: "及时了解博世世界的最新动态和创新成果。",
            BDC_AutoPartsCenter: "产品在线目录",
            bdcNAV1: "探索博世的产品组合，包括柴油和其他产品线，以及车辆应用、OE交叉引用和详细的产品信息。只需点击下面的链接即可浏。",
            bdcNAV2: "配件图书馆",
            bdcNAV3: "测试设备工具和软件服务",
            bdcNAV4: "BDC卓越中心",
            CustomerTrainingstext1: "文档搜素",
            CustomerTrainingstext1_center: "欢迎加入柴油培训计划",
            CustomerTrainingstext1_hint: "Diesel&Beyond是博世柴油机网络的一项赋权培训计划，旨在培养能力，为未来的发展做好研讨会准备。凭借在线和现场互动学习形式的综合课程、专家主导的指导和认证机会，它为研讨会提供了保持竞争力和加强未来发展地位的技能和知识",
            CustomerTrainingstext1_btnL: "",
            CustomerTrainingstext1_btnR: "点击查询历史培训内容！",
            CustomerTrainingstext2: "点击查询当前培训内容！",
            CustomerTrainingstext2_center: "激动人心的客户活动！",
            CustomerTrainingstext2_btnL: "我们定期组织互动客户活动，如柴油之夜和会议，与客户保持联系。在本课程中，您可以通过演示文稿、照片和材料方便地回顾过去的活动，并发现即将到来的活动和社交机会，这样您就不会错过重要的更新和见解。",
            CustomerTrainingstext2_btnR: "点击查询历史活动！",
            CustomerTrainingsnav1_1: "点击查询当前活动！",
            CustomerTrainingsnav1_2: "共轨柴油机系统",
            CustomerTrainingsnav1_3: "常规柴油系统",
            CustomerTrainingsnav1_4: "废气处理",
            NoDataAvailable2: "其他部分",
            // ModuleConcept:"目前没有有效的促销活动。敬请期待后续更新！",
            ModuleConcept_text1: "",
            ModuleConcept_text2: "距离下一次获得抽奖票数还差",
            ModuleConcept_text3: "票数",
            ModuleConcept_text4: "已获得抽奖票数",
            ModuleConcept_text5: "已采购雨刮数",
            ModuleConcept_text6: "*采购数据于每月更新",
            ModuleConcept_text7: "月度排行榜",
            ModuleConcept_text8: "月",

            //Wiper 100:"",
            Wiper_text1: "",
            Wiper_text2: "Wiper 100",
            Wiper_text3: "雨刮100周年活动",
            Wiper_text4: "正确回答以下问题，即可参与雨刮100周年活动！",
            Wiper_text5: "问题：今年，博世正庆祝其____周年纪念？",
            Wiper_text6: "A 60",
            Wiper_text7: "B 80",
            Wiper_text8: "C 100",
            Wiper_text9: "D 120",
            Wiper_text11: "买雨刮赢中国游",
            Wiper_text13: "每日登录赢大奖 ",
            Wiper_text14: "与博世一同欢庆雨刮100周年",
            Wiper_text15_1: "点击抽奖赢积分",
            Wiper_text15_2: "你已收集7/12",
            Wiper_text15_3: "卡牌！",
            Wiper_text16: "继续每日登录以收集全部卡牌，解锁终极大奖励！",
            Wiper_text17: "Your Lucky Cards",
            Wiper_text18: "回答正确，开启雨刮100周年活动体验！",
            Wiper_text19: "回答错误，请选择正确答案才能正常访问本次活动！",
            Wiper_text20: "你收集的卡牌",
            Wiper_text21_1: "抽奖互动",
            Wiper_text21_2: "普通奖励（最大奖励",
            Wiper_text22: "易加积分）",
            Wiper_text23: "抽奖次数",
            Wiper_text24: "点击抽奖",
            Wiper_text25: "卡牌已收集",
            Wiper_text26: "恭喜获奖",
            Wiper_text27: "你已获得",
            Wiper_text28: "今日所剩抽奖机会",
            Wiper_text29: "易加积分",
            Wiper_text30: "抱歉，您未获得奖励，请继续尝试抽奖！",
            Wiper_text31: "预计将于4月份更新，请耐心等待！",


        }
    },
    zh: {
        // 中文
        message: {
            PleaseCheckTheSignUpForEXtraProgram: "请勾选并同意注册eXtra平台！",
            monthlyOrderImport: "月度订单导入",
            SKUOrderImport: "SKU订单导入",
            FileCode: "文件代码",
            FileName: "文件名",
            OrderMonth: "订单月份",
            importTime: "导入时间",
            Operate: "操作",
            importNow: "立即导入",
            DataFile: "数据文件",
            ClickToUpload: "点击上传",
            TemplateFile: "模板文件",
            clickToDownloadTheMonthlyOrderTemplateFile: "单击此处下载月度订单模板文件",
            clickToDownloadTheSKUOrderTemplateFile: "点击下载SKU订单模板文件",
            importData: "导入数据",
            manualUploading: "手动上传",
            Home: "首页",
            WhatSon: "新闻和活动",
            Rewards: "奖励",
            Module: "配件优选店",
            TechWiki: "汽车技术",
            MyAccount: "我的账号",
            BOSCHAZPortal: "博世亚太区一站式采购平台",
            YourApplicationIsPendingReview: "您的申请正在等待审核",
            CorporateInformation: "企业信息",
            LegalNotice: "法律声明",
            DataProtectionPolicy: "数据保护政策",
            PrivacySettings: "隐私设置",
            RobertBoschGmbH: "© 2021 - 2025 博世有限公司，版权所有",
            // 选择国家页:",",
            SelectCountry: "选择国家",
            WarmingReminderYouCanOnlyAccessMalyssiaNow: "您现在只能访问Malyssia。其他国家即将到来！请随时与我们联系",
            // 添加员工:",",
            AddEmployee: "添加员工",
            FillInEmployeeInfo: "填写员工信息",
            SheHeIs: "身份",
            YourApplicationIsAentToYourTheOwnerOfYourCompanyForApproval: "您的申请已开始进行审批。",
            // 表单:",",
            Registration: "登记",
            Step1: "第1步",
            Step2: "第2步",
            MobileNo: "手机",
            FirstName: "名",
            LastName: "姓",
            CompanyName: "公司名称",
            Email: "电子邮件",
            EmailOptional: "电子邮件",
            FullAddress: "完整地址",
            Address: "地址",
            City: "城市",
            PleaseEnter: "请输入",
            ProvinceState: "省/州",
            ZipCode: "邮编",
            Continue: "继续",
            Step3: "第3步",
            IAmA: "我是",
            IAm: "我是",
            RepairSegment: "部门",
            VehicleSegment: "汽车细分市场",
            PreferredDistributor: "经销商",
            Workshop: "工作站",
            Retailer: "零售商",
            TradeLevel: "等级",
            PortalId: "我的ID",
            Distributor: "经销商",
            Diesel: "柴油机",
            Gasoline: "汽油",
            OthersEV: "其他（EV）",
            Motorcycle: "摩托车",
            PassengerCars: "乘用车",
            TrucksBus: "卡车/大巴车",
            NoOfWorkbay: "工作站编号",
            FillIn: "填写",
            Namecard: "名片",
            TakeNamecard: "名片",
            CompanyShopfront: "公司店面",
            PleaseUploadYourCompanyNamecard: "您的公司信息",
            TakePhotoOfCompanyShopfront: "上传公司店面照片",
            PleaseUploadYourCompanyShopfront: "请上传公司店面照片",
            SignUpForEXtraProgram: "注册eXtra",
            PleaseCheckAgain: "请检查必填信息！",
            IsTheGivenInformationCorrect: "请确认所提供的信息是否准确？",
            DoYouAgreeOurPrivacyPolicy: "您同意我们的隐私政策吗？",
            DoYouAgreeOurTermsConditions: "您同意我们的条款和条件吗？",
            ConfirmToRegister: "确认注册",
            PleaseCheckIfTBD: "请核实所提供的信息是否准确无误？",
            Back: "返回",
            Confirm: "确认",
            PleaseCheckIfTheGivenInformationIsCorrect: "请核实所提供的信息是否准确无误？",
            PleaseEnterTheRequiredInfo: "请输入所需信息。",
            pleaseMakeSureIfYouWannaSignUpForEXtraProgram: "请确认注册eXtra",
            AlreadySubmittedPendingApproval: "已提交，等待审批！",
            OwnerMobileNo: "老板手机",
            Manager: "经理",
            Employee: "员工",
            Owner: "老板",
            RequestANewOTP: "获取新的验证码",
            YouHaveSelectdSMSAsNotificationChannel: "您已选择短信作为通知渠道，您将收到您提供手机号码的验证码。请输入验证码以完成注册，",
            DataProtectionGuidelines: "数据保护指南",
            GeneralTermsConditions: "一般条款和条件",
            PleaseEnterYourPhoneNumber: "请输入您的电话号码",
            CellPhoneNumberIsRequired: "手机号码是必填项",
            pleaseAgreeOurTermsAndConditions: "确认同意网站的条款和条件。",
            pleaseAgreeOurDataProtectionPolicy: "确认同意网站的数据保护政策。",
            pleaseAgreeOurLegalNotice: "确认同意网站的法律声明。",
            PleaseChooseYourRegion: "请选择您所在地区",
            PleaseEnterOTP: "请输入验证码",
            LoginToProceed: "登录以继续",
            Login: "登录",
            RegisterNow: "立即注册",
            DontHaveAnAccount: "没有帐户",
            OTP: "验证码",
            RequestANewOTP: "获取新的验证码",
            YourApplicationIsPendingApproval: "您的申请正在等待批准，请稍候！",
            success: "成功",
            rule_list: "历史版本",
            AccountData: "账户数据",
            CountryRegion: "国家/地区",
            Role: "角色",
            ModifyBasicInformation: "公司照片",
            PleaseFillInYourEmail: "您的电子邮件格式不正确，请重新输入！",
            CompanyData: "公司数据",
            eXtraID: "eXtra ID",
            ModifyInformation: "修改信息",
            ModifyKeyInformation: "修改关键信息",
            ChangeCompanyPhoto: "更改公司照片",
            LogOut: "退出",
            NoDataAvailable: "无可用数据",
            Search: "搜索",
            Modify: "修改",
            PleaseCheckTheDataProtectionPolicyAndLegalNotice: "请查看数据保护政策和法律声明！",
            // 人员管理:",",
            RoleManagement: "角色管理",
            Time: "时间",
            Refuse: "拒绝",
            Accept: "接受",
            DoYouConfirmToApproveIt: "您确认批准吗？",
            DoYouConfirmToRejectIt: "您确认要拒绝吗？",
            PleaseConfirmAgain: "通知",
            RoleInformation: "角色信息",
            Name: "姓名",
            Activate: "激活",
            Disable: "禁用",
            IdentitySettings: "身份设置",
            DoYouConfirmToChangeThisInformation: "您确认要更改此信息吗？",
            DoYouConfirmToActivateThisAccount: "您确认激活此帐户吗？",
            DoYouConfirmToDisableThisAccount: "您确认要禁用此帐户吗？",
            // article:",",
            PurchaseRecord: "采购记录",
            TotalPurchase: "采购总额",
            valueSGD: "价值（美元）",
            TotalPurchaseValue: "总购买价值（美元）",
            TotalPurchaseAmt: "总采购金额（美元）",
            ProcurementRecords: "采购记录",
            View: "查看",
            LatestArticles: "最新文章",
            LearnMore: "了解更多>",
            // Autoparts:",",
            AutoParts: "汽车零部件",
            ViewMore: "查看更多>",
            BoschGroup: "博世集团",
            BoschMobilityAftermarket: "博世移动售后市场",
            // BSSList:",",
            WelcomeBoschModulePartner: "欢迎博世模块合作伙伴！",
            MyBenefits: "我的福利 >",
            MoreInfoAboutModule: "更多信息 >",
            AnnualPartsTarget: "年度零件目标",
            StillToGo: "确认前往",
            ContractTarget: "合同目标",
            TotalAchievement: "合计",
            Year: "年份",
            ActualSales: "实际销售额",
            ContractPeriod: "合同期限",
            years: "年",
            JoinDate: "合同开始日期",
            KeepUpTheGreatProgress: "继续！",
            DealerWillGetInTouchWithYouSoon: "经销商会尽快与您联系。",
            ViewMyContract: "查看我的合同",
            Marketing: "营销",
            promotionZone: "晋升",
            Attended: "进行中",
            Achieved: "可领取",
            Received: "已收到",
            Done: "结束",
            Abandoned: "放弃",
            to: "至",
            CurrentPurchase: "当前采购",
            SGD: "SGD",
            MarketingPromotionZone: "营销推广区",
            NotAttended: "无法使用的",
            // contact_us:",",
            Like: "喜欢",
            Comment: "评论",
            SaySometihing: "说点什么",
            Sending: "发送",
            User: "用户",
            PleaseTypeWords: "请输入",
            AutomotiveTech: "汽车技术",
            views: "查看",
            // Home:",",
            FunctionalityInDevelopment: "开发中的功能",
            // Module:",",
            Apply: "申请",
            JoinUsLogIn: "加入我们/登录",
            JoinUs: "加入我们",
            BoschModuleConcept: "博世 module 概念",
            IHaveReadAndAcceptedTheBoschModulePolicy: "我已阅读并接受博世 module 政策",
            SignNow: "签名",
            PleaseFillInTheBelowArea: "请填写以下信息",
            PleaseFillInYourFirstNameUnrecognizedOrIncorrectSignatureWillLeadToRegistrationFailure: "请填写您的名字，无法识别或不正确的签名将导致注册失败",
            PlaeaseFillInYourFirstName: "请填写您的名字",
            pleaseCheckTheBoschModulePolicy: "请查看网站政策",
            KindlyProvideSignatureOrFullName: "请提供名称",
            // MyAccount:",",
            loggedInSuccessfully: "登录成功！",
            IAlreadyHaveAnOTP: "我已经有验证码了",
            Tel: "电话",
            PendingIdentityForReview: "待审查账户",
            EnterBoschModuleTiering: "进入博世 Module >",
            CurrentMember: "当前成员",
            EarnPointsEveryDay: "每天赚取积分",
            eXtraMall: "易家商城",
            eXtraPoints: "易家积分",
            eXtraPoint: "易家积分",
            Go: "继续",
            Redeem: "兑换",
            MyServices: "我的服务",
            eXtra: "易家",
            Order: "顺序",
            Points: "积分",
            Details: "详情",
            Personal: "我的",
            Data: "数据",
            Privacy: "隐私",
            Clause: "条款",
            PersonalData: "个人资料",
            eXtraWokrshopCandidate: "会员资格待定",
            KevinCarRepairServiceCenter: "汽车维修服务中心",
            MoreInfoAboutCompany: "更多关于公司的信息",
            MoreInfoAboutYou: "更多关于我的信息",
            MyFirstName: "我的名字",
            MyLastName: "我的姓",
            BossMobileNumber: "老板手机号",
            // Recordltem:",",
            time: "时间",
            item: "项目",
            Qty: "数量",
            PN: "PN码",
            dealer: "经销商",
            Download: "下载",
            // Rewards:"0,",
            expiresOn: "截止时间",
            ActivityRules: "活动规则",
            CheckInDone: "签到完成",
            CheckInNOW: "立即签到",
            ThePointsDataWillUpdateMonthlyPleaseStayInformedWithUs: "积分数据将每月更新，敬请期待！",
            // Video:",",
            FoundTheQRCode: "查看二维码",
            PleaseUseYourMobilePhoneToLog: "请使用您的手机登录，以便成功扫码！",
            PleaseAllowAuthorizedUseOfYourPhone: "请允许授权使用您的手机摄像头并再次扫描！",
            // WhatsOn:",",
            ThoEvontTeasorGroupOllors: "有什么新闻",
            //刘新增 10/10:",",
            ModuleJoinData: "Module 数据",
            ViewMyContract: "查看我的合同",
            NoContractHint: "我们还没有查询到您的合约，请联系您的博世销售。",
            NoticeOfExpirationOfContract: "您的合约已到期！请等待博世安排续约。",
            ChannelPromotion: "渠道推广",
            OK: "好的",
            Congratulations: "恭喜",
            YouHaveAchievedTheTarget: "你已经达到了目标。",
            PleaseAwaitBoschArrangementForYourEntitlement: "请等待博世安排您的权利！",
            ReceivedTheRewards: "已收到奖励",
            NotYetReceived: "尚未收到",
            // (10/12):",",
            WorkRole: "工作角色",
            ICanNotFindMyDistributor: "找不到我的经销商",
            AllAutoparts: "全部",
            BatterySpecialist: "电池相关",
            Others: "其他",
            Cancel: "取消",
            PleaseEnterTheCorrectCompanyNameAndMobileNumber: "请输入正确的公司名称和手机号码",
            ALL: "全部",
            AccessOurFullRangeOfAvailableProductsOnTheGoSimplyClickOnYourProductGroupOfInterestToDiveIn: "随时随地访问我们的全系列可用产品-只需点击您感兴趣的产品组即可深入了解！",
            searchPartnumberItem: "搜索产品料号、产品名称",
            searchPartnumberDealer: "搜索产品料号、经销商",
            Send: "获取验证码",
            Submit: "提交",
            BoschAutopartsCustomerPortal: "",
            //(10/14):",",
            Reset: "重置",
            SelectAlanguage: "切换语言",
            NotFilled: "无数据",
            Yes: "是",
            NO: "否",
            StartTime: "开始时间",
            EndTime: "结束时间",
            Product: "产品",
            PendingApproval: "待审核",
            AuditRejection: "审核不通过",
            registered: "活跃",
            ResignedDisabled: "禁用/离职",
            frozen: "冻结",
            PleaseRnterYourLoginAccount: "申请已在维修店提交，请通知老板审核",
            AddEmployee: "添加员工",
            ViewDetails: "查看详细信息",
            YourRegistrationApplicationIsCurrentlyUnderReview: "您的注册申请目前正在审核中。",
            IHaveTakenNoteOfThe: "我注意到",
            DataProtectionNotice: "数据保护通知",
            ContactUs: "联系我们",
            YourDetails: "您的详细信息",
            InquiryDetails: "查询详情",
            Description: "描述",
            Subject: "主题",
            ModulesSignUp: "模块注册",
            PleaseFillInAllTheRequiredInformation: "请填写所有必填信息！",
            Expired: "到期",
            PleaseAccessThroughMobileBrowser: "请手机浏览器访问",
            Enter: "确认",
            Partnership: "合作伙伴",
            EGGMALL: "EGG MALL",
            CreateTheEGGMallAccount: "创建EGG MALL平台账号",
            Egg_hint: "您将授权我们使用您的信息创建Egg Mall帐户，且该Egg Mall帐户将与我们平台的帐户进行绑定。",
            IAccept: "我已阅读并同意",
            Egg_check_Policy: "《EGG Mall 隐私政策》",
            ConfirmToCreate: "确认创建",
            PleaseCheckAndAcceptThePrivacyPolicy: "请您阅读并同意隐私政策",
            CreationComplete: "创建成功！",
            OverallAnnualBoshPurchase: "年度Bosch采购总额",
            // 勋章活动:",",
            WelcomeToTheBoschBusinessPortal: "Welcome to the Bosch Business Portal!",
            TBBPBAEFTOIOPJFYAABC: "我们平台专为博世客户提供一站式数字化功能服务。",
            TakeOurTourAndDiscoverWhatsInside: "开启你的旅程，快速了解我们",
            StartTour: "点击开启",
            medalLayer1_head: "通过这个模块",
            medalLayer1: "e-catalogue",
            medalLayer1_tail: "，你可以搜索和筛选所有所属你所在国家可查询的博世产品。",
            medalLayer2_head: "探索我们的",
            medalLayer2: "news section",
            medalLayer2_tail: "来及时了解来自我们博世集团最新的资讯内容",
            medalLayer3_head: "你可以通过博世产品找到我们博世智码",
            medalLayer3: "Smart Code",
            medalLayer3_tail: "，并通过扫码来获取更多产品信息。",
            medalLayer3_btn: "手机设备",
            medalLayer4_head: "通过这个模块",
            medalLayer4: "eXtra rewards",
            medalLayer4_tail: "，你可以查看你最新的易加积分，并通过扫码将获取一定的积分奖励。",
            medalLayer5_head: "点击",
            medalLayer5: "Automotive tech",
            medalLayer5_tail: "模块进入我们的视频百科，了解我们更多产品信息。",
            medalLayer6_head: "模块进入我们的视频百科，了解我们更多产品信息。",
            medalLayer6: "Bosch Module program",
            medalLayer6_tail: "？点击这个模块就能知道！",
            FinishTour: "完成探索旅程",
            Step: "步骤",
            ofTo: "/",
            HallOfFame: "成就勋章",
            BadgeEarned: "已获得",
            AvailableChallenges: "可达成挑战",
            StartChallenge: "开始挑战",
            ContinueChallenge: "继续挑战",
            AvailableBadges: "已获得勋章",
            FeedbackSurvey: "意见反馈",
            medal_form_1: "您已大致了解了我们的网站功能，非常期待您对目前的体验做出真实的反馈！",
            medal_form_2: "您会为我们的网站打多少分？",
            medal_form_3: "（1-5颗星）",
            medal_form_4: "哪个网站功能是你最喜欢的？",
            medal_form_5: "E-catalogue",
            medal_form_6: "Modules Section",
            medal_form_7: "Auto-Tech",
            medal_form_8: "What's On",
            medal_form_9: "Anti-fake",
            medal_form_10: "其他意见反馈",
            medal_form_11: "我们非常期待您的反馈，请点击输入......",
            BadgeLeaderboard: "勋章达人榜",
            TheRankWillBeUpdatedByDay: "榜单排行将每日更新1次",
            AchievedTime: "达成时间",
            MyRank: "我的排行",
            ContinueToComplete: "继续完成",
            YouJustGotEXtraPointsRewardsRorCompleting: "你已完成挑战",
            YouJustGotEXtraPointsRewardsRorCompleting2: "，并且获得相应积分奖励",
            YouJustEarnedBadge: "你已获得1枚勋章",
            Collect: "收下",
            FirstSteps: "第1步",
            andPleaseKeepGoingOn: "请继续完成",
            Welcome: "欢迎",
            Welcome2: "Welcome to the Bosch Business Portal!",
            layer2hint1: "感谢您选择博世，点击以下按钮了解如何完成当前挑战，并获取相应积分奖励和成就勋章。",
            layer2hint2: "成就勋章",
            layer2hint3: "完成任务挑战，获取相应积分奖励，并点亮成就勋章！",
            ContinueToExplore: "继续探索",
            TakeMeThere: "点击前往",
            medal_form_list_1: "达成时间：你未获得任何勋章",
            stepType5Hint: "请先完成上一步挑战",
            ContinueToAchieve: "点击继续",
            // 25 6/11新增:"0,",
            ConnectYourEXtraAccount: "关联你的易加账号",
            ConnectYourEXtraAccount2: "请输入你的易加账号和密码，以便于我们将其与您本网站的账号进行关联。",
            Account: "账号",
            EnterAccountNo: "请输入账号",
            Password: "密码",
            EnterPassword: "输入密码",
            Submit: "点击提交",
            // 25 5/9新增:"0,",
            SignUp: "点击注册",
            LogIn: "登录",
            LogIn_hint: "点击登录已有账号，或者点击注册全新的账号",
            LogIn_hint2: "点击登录已有账号",
            LogIn_hint2_1: "或者点击注册全新的账号",
            WelcomeToBoschBusinessPortal: "欢迎来到博世客户端网站",
            WelcomeTo: "Welcome to",
            BoschBusinessPortal: "Bosch Business Portal",
            LogInSuccessfully: "登录成功！",
            GetYourRewards: "点击领取奖励",
            WarmReminder: "您当前身份处于审核状态，审核通过后即可使用该功能，请耐心等待！'",
            //2025 8/23新增:"0,",
            News_pdates: "最新资讯",
            CustomerTrainingsEvents: "客户培训和活动",
            News: "新闻",
            Promotion: "促销",
            E_Magizines: "电子杂志",
            FileFormat: "文件格式",
            FindOutMoreHere: "点击查看更多内容。",
            AccessPastTrainingsHere: "点击查询历史培训内容！",
            AccessCurrentTrainingsHere: "点击查询当前培训内容！",
            BDCHub: "BDC中心",
            BDCExcellenceHub: "BDC柴油中心",
            BDCtitle: "最新资讯",
            BDCcenter: "及时了解博世世界的最新动态和创新成果。",
            BDC_AutoPartsTitle: "产品在线目录",
            BDC_AutoPartsCenter: "探索博世的产品组合，包括柴油和其他产品线，以及车辆应用、OE交叉引用和详细的产品信息。只需点击下面的链接即可浏。",
            bdcNAV1: "配件图书馆",
            bdcNAV2: "测试设备工具和软件服务",
            bdcNAV3: "BDC卓越中心",
            bdcNAV4: "文档搜素",
            CustomerTrainingstext1: "欢迎加入柴油培训计划",
            CustomerTrainingstext1_center: "Diesel&Beyond是博世柴油机网络的一项赋权培训计划，旨在培养能力，为未来的发展做好研讨会准备。凭借在线和现场互动学习形式的综合课程、专家主导的指导和认证机会，它为研讨会提供了保持竞争力和加强未来发展地位的技能和知识",
            CustomerTrainingstext1_hint: "",
            CustomerTrainingstext1_btnL: "点击查询历史培训内容！",
            CustomerTrainingstext1_btnR: "点击查询当前培训内容！",
            CustomerTrainingstext2: "激动人心的客户活动！",
            CustomerTrainingstext2_center: "我们定期组织互动客户活动，如柴油之夜和会议，与客户保持联系。在本课程中，您可以通过演示文稿、照片和材料方便地回顾过去的活动，并发现即将到来的活动和社交机会，这样您就不会错过重要的更新和见解。",
            CustomerTrainingstext2_btnL: "点击查询历史活动！",
            CustomerTrainingstext2_btnR: "点击查询当前活动！",
            CustomerTrainingsnav1_1: "共轨柴油机系统",
            CustomerTrainingsnav1_2: "常规柴油系统",
            CustomerTrainingsnav1_3: "废气处理",
            CustomerTrainingsnav1_4: "其他部分",
            NoDataAvailable2: "目前没有有效的促销活动。敬请期待后续更新！",
            // ModuleConcept:"",
            ModuleConcept_text1: "距离下一次获得抽奖票数还差",
            ModuleConcept_text2: "票数",
            ModuleConcept_text3: "已获得抽奖票数",
            ModuleConcept_text4: "已采购雨刮数",
            ModuleConcept_text5: "*采购数据于每月更新",
            ModuleConcept_text6: "月度排行榜",
            ModuleConcept_text7: "月",
            ModuleConcept_text8: "雨刮100周年活动介绍",

            //Wiper 100:"",
            Wiper_text1: "Wiper 100",
            Wiper_text2: "雨刮100周年活动",
            Wiper_text3: "正确回答以下问题，即可参与雨刮100周年活动！",
            Wiper_text4: "问题：今年，博世正庆祝其____周年纪念？",
            Wiper_text5: "A 60",
            Wiper_text6: "B 80",
            Wiper_text7: "C 100",
            Wiper_text8: "D 120",
            Wiper_text9: "买雨刮赢中国游",
            Wiper_text11: "每日登录赢大奖 ",
            Wiper_text13: "与博世一同欢庆雨刮100周年",
            Wiper_text14: "点击抽奖赢积分",
            Wiper_text15_1: "你已收集7/12",
            Wiper_text15_2: "卡牌！",
            Wiper_text15_3: "继续每日登录以收集全部卡牌，解锁终极大奖励！",
            Wiper_text16: "Your Lucky Cards",
            Wiper_text17: "回答正确，开启雨刮100周年活动体验！",
            Wiper_text18: "回答错误，请选择正确答案才能正常访问本次活动！",
            Wiper_text19: "你收集的卡牌",
            Wiper_text20: "抽奖互动",
            Wiper_text21_1: "普通奖励（最大奖励",
            Wiper_text21_2: "易加积分）",
            Wiper_text22: "抽奖次数",
            Wiper_text23: "点击抽奖",
            Wiper_text24: "卡牌已收集",
            Wiper_text25: "恭喜获奖",
            Wiper_text26: "你已获得",
            Wiper_text27: "今日所剩抽奖机会",
            Wiper_text28: "易加积分",
            Wiper_text29: "抱歉，您未获得奖励，请继续尝试抽奖！",
            Wiper_text30: "预计将于4月份更新，请耐心等待！",
            Wiper_text31: "",


        }
    }
};
const localLanguage = localStorage.getItem('localLanguage') || 'en'
const i18n = new VueI18n({
    locale: localLanguage, // 默认语言
    messages,
});

export default i18n;